(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fabout.tsx&page=%2Fabout!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__("./src/pages/about.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Elements/Carousel/Carousel.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ WikiCarousel; },
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/embla-carousel-react/embla-carousel-react.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react-slick/lib/index.js");
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/slick-carousel/slick/slick.css");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/slick-carousel/slick/slick-theme.css");
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);











const WikiCarousel = (param)=>{
    let { data , item , options , plugins , Buttons  } = param;
    const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ...options
    }, plugins);
    const [selectedIndex, setSelectedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [scrollSnaps, setScrollSnaps] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [prevBtnEnabled, setPrevBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [nextBtnEnabled, setNextBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollTo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((index)=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    const onSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        setPrevBtnEnabled(emblaApi.canScrollPrev());
        setNextBtnEnabled(emblaApi.canScrollNext());
    }, [
        emblaApi,
        setSelectedIndex
    ]);
    const scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect();
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
    }, [
        emblaApi,
        setScrollSnaps,
        onSelect
    ]);
    const PrevButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--prev",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowBackIos */ .oTp
            })
        });
    };
    const NextButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--next",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowForwardIos */ .Djl
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
                ref: emblaRef,
                overflow: "hidden",
                w: "full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                    w: "full",
                    children: data === null || data === void 0 ? void 0 : data.map((e, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            flex: "0 0 auto",
                            minW: "0",
                            maxW: "100%",
                            children: item(e)
                        }, i))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                w: "full",
                alignItems: "center",
                gap: "3",
                pt: "4",
                justifyContent: "center",
                children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_11__/* .RiCheckboxBlankCircleFill */ .o$3,
                        fontSize: "8px",
                        color: index !== selectedIndex ? "brand.200" : "brand.500",
                        cursor: "pointer",
                        onClick: ()=>scrollTo(index)
                    }, index))
            }),
            Buttons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevButton, {
                        onClick: scrollPrev,
                        enabled: prevBtnEnabled
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextButton, {
                        onClick: scrollNext,
                        enabled: nextBtnEnabled
                    })
                ]
            })
        ]
    });
};
const ArrowBtn = (param)=>/*#__PURE__*/ {
    let { ArrowIcon , onClick , top , isNext  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
        top: top,
        position: "absolute",
        transform: "translate(0, 150%)",
        display: "grid",
        placeItems: "center",
        onClick: onClick,
        cursor: "pointer",
        borderWidth: "1px",
        borderColor: "carouselArrowBorderColor",
        zIndex: 99,
        bgColor: "carouselArrowBg",
        borderRadius: "50%",
        w: "40px",
        h: "40px",
        right: isNext ? "-20px" : "unset",
        left: isNext ? "unset" : "-20px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
            as: ArrowIcon,
            color: "grey"
        })
    });
};
const Carousel = (param)=>/*#__PURE__*/ {
    let { settings , children , topArrow  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...settings,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronRight */ .Dli,
            isNext: true
        }),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronLeft */ .bUI
        }),
        children: children
    });
};


/***/ }),

/***/ "./src/components/Elements/Image/Image.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* unused harmony export cfLoader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/image.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const BASE_URL = "https://iq.wiki";
const cfLoader = (param)=>{
    let { src , width , quality  } = param;
    const params = [
        "width=".concat(width)
    ];
    if (quality) params.push("quality=".concat(quality));
    const paramsString = params.join(",");
    return "".concat(BASE_URL, "/cdn-cgi/image/").concat(paramsString, "/").concat(normalizeSrc(src));
};
const normalizeSrc = (src)=>{
    return src.startsWith("/") ? src.slice(1) : src;
};
const Image = (param)=>/*#__PURE__*/ {
    let { src , alt , priority , placeholder , blurDataURL , hideOnError , sizes , objectFit ="cover" , imgBoxSize , imgW , imgH , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        h: "".concat(imgBoxSize || imgH, "px"),
        w: "".concat(imgBoxSize || imgW, "px"),
        ...rest,
        overflow: "hidden",
        position: "relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            quality: 95,
            style: {
                objectFit,
                objectPosition: "top",
                width: "100%",
                height: "100%"
            },
            loader: typeof src === "string" && src.startsWith("http") ? cfLoader : undefined,
            fill: !(imgW && imgH) || !imgBoxSize,
            src: src,
            alt: alt,
            onError: (e)=>{
                if (hideOnError) {
                    e.currentTarget.style.visibility = "hidden";
                }
            },
            priority: priority,
            sizes: sizes,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            loading: priority ? "eager" : "lazy",
            width: imgBoxSize || imgW,
            height: imgBoxSize || imgH
        })
    });
};


/***/ }),

/***/ "./src/components/SEO/Static.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ CareersHeader; },
/* harmony export */   "BV": function() { return /* binding */ FaqSEO; },
/* harmony export */   "FV": function() { return /* binding */ TermsHeader; },
/* harmony export */   "Q_": function() { return /* binding */ GuidelinesHeader; },
/* harmony export */   "XJ": function() { return /* binding */ PrivacyPolicySEO; },
/* harmony export */   "d5": function() { return /* binding */ AboutHeader; }
/* harmony export */ });
/* unused harmony export CaPrivacyRightsHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const AboutHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "About",
        description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token.",
        canonical: "https://iq.wiki/static/about",
        openGraph: {
            title: "About",
            description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token."
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const FaqSEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "FAQ",
        description: "Frequently Asked Questions about IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/faq",
        openGraph: {
            title: "FAQ",
            description: "Frequently Asked Questions about IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const PrivacyPolicySEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Policy",
        description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/privacy",
        openGraph: {
            title: "Our Policy",
            description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CareersHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Jobs",
        description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/careers",
        openGraph: {
            title: "Jobs",
            description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CaPrivacyRightsHeader = ()=>/*#__PURE__*/ _jsx(NextSeo, {
        title: "CA Privacy Rights",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/CaPrivacyRights",
        openGraph: {
            title: "CA Privacy Rights",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const TermsHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Terms of Service ",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/terms",
        openGraph: {
            title: "Terms of Service",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const GuidelinesHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Guidelines",
        description: "IQ.Wiki guidelines for the community and network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/guidelines",
        openGraph: {
            title: "Our Guidelines",
            description: "IQ.Wiki guidelines for the community and network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });


/***/ }),

/***/ "./src/data/Constants.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ITEM_PER_PAGE; },
/* harmony export */   "L": function() { return /* binding */ WIKI_METADATA_VALUE_LIMIT; },
/* harmony export */   "Nf": function() { return /* binding */ FETCH_DELAY_TIME; },
/* harmony export */   "Vl": function() { return /* binding */ CATEGORY_DESCRIPTION_WORD_LIMIT; },
/* harmony export */   "a": function() { return /* binding */ WIKI_SUMMARY_LIMIT; },
/* harmony export */   "ag": function() { return /* binding */ WIKI_IMAGE_ASPECT_RATIO; },
/* harmony export */   "ft": function() { return /* binding */ MEDIA_POST_DEFAULT_ID; },
/* harmony export */   "hj": function() { return /* binding */ WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL; },
/* harmony export */   "xh": function() { return /* binding */ IMAGE_BOX_SIZE; }
/* harmony export */ });
/* unused harmony exports WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS, GPT3_COST_PER_1K_TOKENS, GPT3_MAX_TRIES */
const ITEM_PER_PAGE = 12;
const FETCH_DELAY_TIME = 3000;
const CATEGORY_DESCRIPTION_WORD_LIMIT = 200;
const MEDIA_POST_DEFAULT_ID = "UPLOADING_ID";
const WIKI_IMAGE_ASPECT_RATIO = 4 / 3;
const WIKI_METADATA_VALUE_LIMIT = 255;
const WIKI_SUMMARY_LIMIT = 255;
const WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL = 10 * 60 * 1000 // 10 Mins
;
const WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS = 5;
const GPT3_COST_PER_1K_TOKENS = 0.02;
const GPT3_MAX_TRIES = 3;
const IMAGE_BOX_SIZE = 150;


/***/ }),

/***/ "./src/pages/about.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/components/About/AboutHero.tsx





const AboutHero = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const aboutHeroSrc = (0,dist_index_esm/* useColorModeValue */.ff)("about-hero-light.svg", "about-hero-dark.svg");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        mx: "auto",
        maxW: {
            base: "100%",
            xl: "90%",
            "2xl": "1280px"
        },
        spacing: {
            base: 0,
            md: "2"
        },
        flexDirection: {
            base: "column",
            xl: "row"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mx: "auto",
                mb: {
                    base: 0,
                    xl: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        textAlign: {
                            base: "center",
                            xl: "left"
                        },
                        w: {
                            base: "100%"
                        },
                        pr: {
                            base: "0",
                            xl: "8"
                        },
                        mx: {
                            base: "auto",
                            xl: 0
                        },
                        fontSize: {
                            base: "32",
                            md: "36",
                            "2xl": "42"
                        },
                        mt: {
                            base: 0,
                            md: 10
                        },
                        mb: {
                            base: 5,
                            xl: 10
                        },
                        fontWeight: "black",
                        lineHeight: "shorter",
                        children: "".concat(t("aboutHeroHeading"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        textAlign: {
                            base: "center",
                            xl: "left"
                        },
                        fontSize: {
                            base: "16px",
                            md: "18px",
                            xl: "24px"
                        },
                        mb: 4,
                        mx: {
                            md: "auto",
                            xl: "0"
                        },
                        w: {
                            base: "100%",
                            md: "80%",
                            xl: "80%"
                        },
                        children: "".concat(t("aboutHeroPhrase"))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    objectFit: "contain",
                    imgBoxSize: 450,
                    maxW: "90vw",
                    className: "teamMember__image",
                    src: "/images/svg-images/".concat(aboutHeroSrc),
                    alt: "Bringing knowledge to the blockchain.",
                    priority: true
                })
            })
        ]
    });
};
/* harmony default export */ var About_AboutHero = (AboutHero);

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
;// CONCATENATED MODULE: ./src/data/OurMissionData.ts
const OurMission = [
    "We are the primary source of objective, high-quality knowledge on the Internet today for everything related to blockchain technology and cryptocurrencies. Our vision is to make blockchain more discoverable and accessible around the world and empower users with the information they can trust.",
    "For full transparency, every edit on IQ.wiki is recorded on the Polygon blockchain with the transaction hash stored on-chain. The data and images uploaded as part of each wiki are stored on the IPFS network and the hashes are included on each page for the users to verify.",
    "IQ.wiki also integrates artificial intelligence in our mission to educate the world on blockchain technology. We use AI to scale our content and make it easier for knowledge to be shared.\xa0 IQ.wiki integrates OpenAI’s GPT-4 for tasks including summarizing wiki articles.",
    "Whether you’re new to the space, a shadowy super coder, a DeFi degen, ETH maxi, or an NFT flipper, IQ.wiki is the place to learn and share knowledge about the crypto space."
];

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/About/AboutFeaturesCard.tsx



const AboutFeaturesCard = (param)=>/*#__PURE__*/ {
    let { title , content , icon  } = param;
    return (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        bgColor: "aboutFeaturesCardBg",
        border: "1px solid",
        borderColor: "aboutFeaturesCardBorder",
        p: 8,
        rounded: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                as: icon,
                mb: 4,
                w: "40px",
                h: "40px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                fontWeight: 700,
                fontSize: {
                    base: "18px",
                    lg: "20px"
                },
                mb: 4,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: 500,
                fontSize: {
                    base: "14px",
                    md: "16px",
                    lg: "18px"
                },
                children: content
            })
        ]
    });
};
/* harmony default export */ var About_AboutFeaturesCard = (AboutFeaturesCard);

;// CONCATENATED MODULE: ./src/components/About/logos/iq.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgIq = function SvgIq(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.577 11.768c0 .445-.081.871-.23 1.264a3.567 3.567 0 0 1-6.702-.095c-2.879.207-4.525-1.078-5.21-3.527-1.728-.47-3-2.048-3-3.924 0-1.213.532-2.302 1.376-3.046a4.057 4.057 0 0 1 2.696-1.02c1.185 0 2.252.505 2.996 1.313a3.17 3.17 0 0 1 1.738-.516 3.181 3.181 0 0 1 3.185 3.137v.099a2.377 2.377 0 0 1 2.405.89c.302.4.48.895.48 1.433a2.359 2.359 0 0 1-.64 1.621c.564.63.906 1.46.906 2.37",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.203 5.199a3.913 3.913 0 0 0-1.04 2.66 3.933 3.933 0 0 0 4.77 3.842m-8.597-7.77a2.734 2.734 0 0 0 2.729 2.54m4.35-.528c.293-.242.64-.41 1.012-.49m-4.924-2.72c-.458.297-.835.71-1.088 1.197",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M21.577 11.768a3.562 3.562 0 0 1-3.564 3.559 3.566 3.566 0 0 1-3.368-2.39c-2.879.207-4.525-1.078-5.21-3.527-1.728-.47-3-2.048-3-3.924a4.069 4.069 0 0 1 4.072-4.066c1.185 0 2.252.505 2.996 1.313a3.183 3.183 0 0 1 4.924 2.666v.054a2.379 2.379 0 0 1 2.886 2.323c-.001.627-.244 1.196-.641 1.621.563.63.905 1.46.905 2.37Z",
    stroke: "#4A5568",
    strokeWidth: 0.81,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M20.673 9.397s-.277-.286-.655-.585m-9.975 7.04a3.202 3.202 0 0 1-.295-1.034",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M17.031 13.378c.126.349.19.717.19 1.088 0 1.909-1.677 3.455-3.747 3.455-1.535 0-2.854-.85-3.432-2.068a2.953 2.953 0 0 1-1.664.512c-1.377 0-2.539-.946-2.903-2.24-.26.064-.528.097-.796.096a3.254 3.254 0 0 1-1.182-6.286 2.602 2.602 0 0 1-.073-.613c0-1.63 1.517-2.95 3.388-2.95 1.074 0 2.033.435 2.653 1.115a3.555 3.555 0 0 1 1.683-.42c1.896 0 3.433 1.468 3.433 3.28 0 .042 0 .085-.003.127 1.565.287 2.754 1.722 2.754 3.449 0 .519-.107 1.012-.3 1.455",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M15.814 11.766c.559.413.986.97 1.216 1.61m-11.557.746a3.173 3.173 0 0 1-.118-.864c0-1.223.689-2.281 1.69-2.787m-2.7-2.742c-.297.03-.581.1-.849.204m5.969-2.448h0m0 0c-.426.23-.795.542-1.084.916",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M17.031 13.378c.126.349.19.717.19 1.088 0 1.909-1.677 3.455-3.747 3.455-1.535 0-2.854-.85-3.432-2.068a2.953 2.953 0 0 1-1.664.512c-1.377 0-2.539-.946-2.903-2.24-.26.064-.528.097-.796.096a3.254 3.254 0 0 1-1.182-6.286 2.602 2.602 0 0 1-.073-.613c0-1.63 1.517-2.95 3.388-2.95 1.074 0 2.033.435 2.653 1.115a3.555 3.555 0 0 1 1.683-.42c1.896 0 3.433 1.468 3.433 3.28 0 .042 0 .085-.003.127 1.565.287 2.754 1.722 2.754 3.449 0 .519-.107 1.012-.3 1.455Z",
    stroke: "#4A5568",
    strokeWidth: 0.81,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M11.648 9.448A3.24 3.24 0 0 1 14 8.422c.197 0 .388.017.575.052m-.215 4.117a2.588 2.588 0 0 1-2.025.973 2.59 2.59 0 0 1-2.008-4.225",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M13.483 14.846c0-.508-.128-.986-.354-1.404m-5.062-.249a2.958 2.958 0 0 1 1.868-1.245m-6.488-.978a2.8 2.8 0 0 1 2.617.296m2.711-2.678a1.97 1.97 0 0 1-1.928-.477m10.434.351a1.568 1.568 0 0 1 1.22-.285",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M20.95 9.4c.37-.46.573-1.029.573-1.623a2.594 2.594 0 0 0-2.891-2.572 3.4 3.4 0 0 0-5.096-2.742 4.296 4.296 0 0 0-3.03-1.254A4.29 4.29 0 0 0 6.43 4.177c-1.806.169-3.217 1.515-3.217 3.145 0 .162.014.324.042.485a3.441 3.441 0 0 0-2.045 3.16 3.472 3.472 0 0 0 4.122 3.404c.454 1.308 1.68 2.205 3.047 2.205.555 0 1.1-.145 1.58-.422.677 1.21 2.03 1.978 3.516 1.978 1.808 0 3.335-1.128 3.808-2.665a3.778 3.778 0 0 0 4.507-3.7c0-.865-.297-1.7-.839-2.368Z",
    stroke: "#4A5568",
    strokeWidth: 1.621,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M10.508 0A5.477 5.477 0 0 0 5.56 3.1c-2.019.488-3.462 2.11-3.553 4.028A4.67 4.67 0 0 0 0 10.967c0 2.55 2.056 4.63 4.6 4.673a4.447 4.447 0 0 0 3.78 2.145c.394 0 .782-.052 1.159-.156.973 1.081 2.404 1.712 3.936 1.712a5.362 5.362 0 0 0 2.908-.85 4.984 4.984 0 0 0 1.66-1.744A4.989 4.989 0 0 0 23 11.768c0-.845-.212-1.666-.616-2.399a3.785 3.785 0 0 0-.732-4.244 3.785 3.785 0 0 0-2.006-1.08 4.611 4.611 0 0 0-5.909-2.996A5.502 5.502 0 0 0 10.507 0Zm0 .786c1.134 0 2.247.42 3.099 1.163a3.822 3.822 0 0 1 5.403 2.816 3.018 3.018 0 0 1 2.938 3.012c-.001.572-.165 1.133-.472 1.617.477.695.737 1.526.737 2.374a4.202 4.202 0 0 1-4.65 4.17c-.646 1.558-2.275 2.617-4.088 2.617-1.495 0-2.865-.7-3.67-1.851a3.6 3.6 0 0 1-1.425.295c-1.43 0-2.722-.856-3.317-2.162a3.896 3.896 0 0 1-4.276-3.87 3.89 3.89 0 0 1 2.012-3.405 3.226 3.226 0 0 1-.009-.24c0-1.76 1.413-3.237 3.328-3.533a4.694 4.694 0 0 1 4.39-3.003",
    fill: "#F0F0F0"
  })));
};

/* harmony default export */ var iq = (SvgIq);
;// CONCATENATED MODULE: ./src/components/About/AboutFeatures.tsx








const AboutFeatures = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
        spacing: 8,
        maxW: {
            base: "100%",
            xl: "90%",
            "2xl": "1280px"
        },
        mx: "auto",
        mt: {
            base: 5,
            md: "24 !important"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                fontWeight: "bold",
                lineHeight: "shorter",
                textAlign: "center",
                size: "lg",
                children: "".concat(t("aboutFeatHeading"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                m: "0 !important",
                children: OurMission.map((mission, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        align: {
                            base: "left",
                            lg: "center"
                        },
                        maxW: "90%",
                        mx: "auto",
                        textAlign: "center",
                        fontSize: {
                            base: "14px",
                            md: "16px",
                            lg: "20px"
                        },
                        lineHeight: {
                            base: "20px",
                            md: "24px",
                            lg: "32px"
                        },
                        mt: {
                            base: "8",
                            md: 10
                        },
                        children: mission
                    }, i))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                columns: [
                    1,
                    1,
                    2,
                    2,
                    3
                ],
                spacing: {
                    base: "8",
                    md: 4
                },
                mt: {
                    base: "45px !important ",
                    md: "24 !important"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutFeaturesCard, {
                        title: "".concat(t("abtFeatOneHeading")),
                        content: "".concat(t("abtFeatOneContent")),
                        icon: md_index_esm/* MdOutlinePublic */.Ekd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutFeaturesCard, {
                        title: "".concat(t("abtFeatTwoHeading")),
                        content: "".concat(t("abtFeatTwoContent")),
                        icon: iq
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutFeaturesCard, {
                        title: "".concat(t("abtFeatThreeHeading")),
                        content: "".concat(t("abtFeatThreeContent")),
                        icon: md_index_esm/* MdOutlinePeopleAlt */.Zs9
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var About_AboutFeatures = (AboutFeatures);

;// CONCATENATED MODULE: ./src/components/About/logos/cnn.svg
var cnn_path;

function cnn_extends() { cnn_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cnn_extends.apply(this, arguments); }



var SvgCnn = function SvgCnn(props) {
  return /*#__PURE__*/react.createElement("svg", cnn_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.4 223.6"
  }, props), cnn_path || (cnn_path = /*#__PURE__*/react.createElement("path", {
    d: "M465.3 1.1h-25.7v177.8c.8 6.1-2.3 12.1-8.3 15.1-.8 0-.8.8-1.5.8h-1.5c-5.3 1.5-10.6-.8-13.6-5.3l-.8-.8v-.8C365.4 110 335.2 60.8 322.3 40.4c-.8-1.5-2.3-2.3-4.5-2.3-2.3.8-3 3-3 5.3v136.2c.8 6.1-3 11.3-7.6 13.6 0 0-.8 0-.8.8h-3.2c-5.3.8-10.6-2.3-13.6-6.8C241.4 110 211.1 60.8 199 40.4c-.8-1.5-2.3-2.3-4.5-2.3-2.3.8-3 3-3 5.3v136.2c0 3-1.5 6.1-3 8.3-.8 0-.8.8-.8.8v.8l-.8.8-.8.8c-2.3 2.3-5.3 3-8.3 3h-77.2c-5.3-.8-9.8-1.5-14.4-2.3-15.1-3.9-28.7-11.4-39.3-22.8l-.8-.8c-7.6-9.1-13.6-18.9-17.4-30.3-.8-3.8-1.5-6.8-1.5-10.6 0-.8 0-.8-.8-1.5-.8-4.5-.8-9.8-.8-14.4v-.8c0-15.9 3.8-31.8 12.1-46.2C40 60.6 43 56.8 46 53.8c0 0 0-.8.8-.8 16-17.1 38.7-27 62.2-26.2h39.3V1.1h-34C81.8-.4 50.7 11.7 28 35.1 9.1 55.5-.8 82.8 0 110.8c-.8 28 9.8 55.2 29.5 75.7 22.7 23.5 54.5 36.3 87 34.8h59.8c11.3.8 22.7-3.8 31-11.3 8.3-9.1 12.1-20.4 11.3-32.5v-56l46.9 77.9c5.3 8.3 12.1 15.1 21.2 19.7 7.6 3.8 16.6 5.3 25 3.8 8.3-1.5 15.9-6.1 21.2-12.1 6.1-7.6 9.1-17.4 9.1-27.2v-62l46.9 77.9c4.5 8.3 12.1 15.9 21.2 19.7 7.6 3.8 16.6 5.3 25 3.8 8.3-1.5 15.9-6.1 21.2-12.1 6.1-7.6 9.1-17.4 9.1-27.2-.1-.3-.1-182.6-.1-182.6zm-43.1 180.8c.8 1.5 2.3 2.3 3.8 2.3 2.3-.8 3-3 2.3-5.3V1.1h-25.8v103.7l-43.9-76.4c-5.3-9.8-13.6-18.2-24.2-23.5-8.3-3.8-17.4-5.3-25.7-3s-15.9 6.8-20.4 13.6c-6.1 7.6-9.1 16.6-8.3 25.7v63.6l-44.6-77.2c-5.3-9.8-13.6-18.2-24.2-23.5-7.6-3.8-17.4-5.3-25.7-3s-16 6.8-21.3 13.6c-3 4.5-5.3 9.1-6.8 14.4-.8 3.8-1.5 7.6-1.5 11.3v109.7c0 2.3-.8 3.8-2.3 5.3s-3 2.3-5.3 2.3h-34c-15.1.8-29.5-4.5-40.9-15.1-8.3-8.4-12.9-20.5-12.9-32.6-.8-25.7 20.4-46.9 46.2-47.7h40.8v-25h-38.6c-20.4-.7-40.8 7.6-54.4 22.8-3 3.8-5.3 7.6-8.3 11.3-6.8 12.1-10.6 25.7-10.6 39.3 0 4.5.8 9.8 1.5 14.4.8 3 1.5 6.8 2.3 9.8 3 9.8 8.3 18.2 15.1 25.7 9.1 9.8 21.2 16.6 34 20.4 4.5 1.5 9.8 2.3 14.4 2.3h73.4c1.5 0 3-.8 4.5-1.5 1.5-.8 1.5-3 1.5-4.5V44.2c-.8-6.1 3-12.1 9.1-14.4l.8-.8h2.3c5.3-1.5 10.6.8 14.4 5.3 0 .8.8.8.8 1.5 12.1 20.4 42.4 69.6 90.8 147.5.8 1.5 2.3 2.3 3.8 2.3 1.5-.8 3-3 2.3-5.3V44.2c-.8-6.1 3-12.1 9.1-14.4l.8-.8h2.3c5.3-1.5 10.6.8 14.4 5.3 0 .8.8.8.8 1.5 9.5 19 39.8 68.2 88.2 146.1z"
  })));
};

/* harmony default export */ var cnn = (SvgCnn);
;// CONCATENATED MODULE: ./src/components/About/logos/forbes.svg
var forbes_path, forbes_path2, forbes_path3;

function forbes_extends() { forbes_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return forbes_extends.apply(this, arguments); }



var SvgForbes = function SvgForbes(props) {
  return /*#__PURE__*/react.createElement("svg", forbes_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1391 363.9",
    xmlSpace: "preserve"
  }, props), forbes_path || (forbes_path = /*#__PURE__*/react.createElement("path", {
    className: "forbes_svg__st0",
    d: "M493.2 210.5c-5.2-44.4-24-76.9-55.1-95.1-34.5-20.3-87-21.5-124.2-2.8-26.9 13.5-48.9 39.5-58.7 69.4-10.1 30.8-10.1 71.3 0 102.8 6.5 20.2 15.2 34.9 28.7 48.3 16.2 16 37.4 26.3 61.7 29.8 8.7 1.3 36.1 1.3 45 0 4.2-.6 11.6-2.2 16.3-3.6 44-12.7 74-46.5 84.3-94.9 2.5-11.7 3.6-40.3 2-53.9zM418 263.8c-3.3 46.7-13.4 72-32.3 80.8-6.8 3.2-19 3.4-25.6.4-16.4-7.5-28.1-30.1-33.9-65.9-3.7-22.7-4.1-73.2-.7-98 4.7-34.8 14.7-55.3 30.3-62.2 10.7-4.8 25.5-1.9 35 6.7 21.2 18.9 31.8 73.2 27.2 138.2z"
  })), forbes_path2 || (forbes_path2 = /*#__PURE__*/react.createElement("path", {
    className: "forbes_svg__st0",
    d: "M132.2 34h31.5c36.2 0 42.1.8 54.9 7 18.6 9.1 32.1 27.1 44 58.5 4.8 12.7 4.8 12.7 15.5 9.5l7.1-2.2-.7-46.1c-.4-25.4-.9-47.9-1.3-50.1l-.6-4-138-.3C68.7 6.1 5.1 6.2 3.3 6.5L0 7.1l.3 8.2.3 8.2 10.5 1.3c13.6 1.6 21.8 5.5 26.6 12.5 10.9 15.9 12.9 37.5 12.8 140.2 0 109.4-2.3 136-12.8 149.8-5.4 7.1-9.8 9.4-22.1 11.7-16 3-15.5 2.6-15.5 10.9 0 4.6.4 7.1 1.2 7.4 1.8.7 178.3.8 180.2.1 2.4-.9 2.3-14-.2-15.2-1-.5-6.9-1.7-13.2-2.6-6.3-.9-13.3-2.5-15.5-3.5-11.6-5-18-18.9-20.4-44.1-1.7-18.1-3.1-51.3-3.1-75.9v-22.6l10.8.3c22.9.7 34.7 1.9 39.5 4 10.4 4.6 18.7 17.4 23.1 35.2l2.3 9.5 8.2.3 8.2.3V122.9l-8.2.3-8.2.3-2.4 9.5c-4.6 18.4-12.2 29.7-23.2 34.8-4.5 2.1-7.7 2.7-18.5 3.3-7.2.4-17.2.8-22.3.8l-9.2.1v-29.8c0-29.8 1.6-93.2 2.6-103l.4-5.2zm541.3 65c-11.6 0-17.9 1.3-27.3 5.6-17.1 7.9-30 20.7-41.5 41.4l-3.6 6.5.5-11.5c.3-6.3.7-18.1.9-26.2l.5-14.8h-2.5c-3.2 0-102.2 19.8-105.2 21-1.9.8-2.2 1.7-2.2 6.4 0 4.9.2 5.6 2.2 6 1.2.3 5.8 1.1 10.1 2 8.8 1.7 11.4 3 15 7.8 6.7 8.8 8 24.4 8 90.3-.1 53.9-1.2 80.7-3.7 89.1-3.1 10.3-8.7 15.5-18.4 17.4-3.1.6-7.3 1.4-9.2 1.8l-3.5.7-.3 6.9c-.2 4.9.1 7.2 1 7.7.7.5 34.6.7 75.3.6l74-.2.3-7.8c.2-4.3-.1-7.8-.5-7.8-5.7 0-23.4-2.4-26.1-3.6-8.3-3.5-12.4-11-14.1-26.2-2-17.9-3.3-62.2-2.7-98.6.6-36.7.6-36.9 2.9-39.3 5.4-5.8 18.9-10.2 31.1-10.3 9.8 0 19.8 2.5 30.5 7.6 5.1 2.5 9.9 4.3 10.5 4 1.3-.5 25.6-64.7 25.6-67.7 0-4.3-13.8-8.8-27.6-8.8zm710.9 146.9c-8.4-16.8-23.9-28.3-56.3-41.9-26.5-11.1-39.8-18.7-47.9-27.6-6.6-7.2-8.5-13-7.9-23.8.6-9.9 3-15.9 9.3-22.5 8-8.5 19-11.5 32.2-8.8 21.6 4.6 35.5 19.5 47.4 51.2 4.3 11.3 4.8 11.6 12.4 8.8l4.8-1.8-.2-13c-.1-7.1-.5-22.2-.8-33.4l-.6-20.4-3.6-1.5c-19.8-8.4-57.5-13.6-82-11.3-27.9 2.5-48.4 11.4-64.2 27.7-15.7 16.2-22.8 35.3-21.5 57.9 1 18.7 6.6 32.1 18.1 43.9 10.7 10.9 19.7 16.1 45.4 26.2 41.5 16.2 52.5 25.8 52.4 45.8-.1 16.9-9 29.2-25.4 35-5.8 2.1-20.6 2-28.5 0-20.6-5.4-36.4-23.3-49.9-56.5l-3.5-8.5-4.1.2c-2.2.1-5.3.8-6.8 1.5l-2.8 1.3.3 14.5c.1 8 .5 24.8.9 37.3l.6 22.8 4.6 2c9.4 4.1 37.8 10.3 55.6 12.2 2.2.2 14.3.3 27 .2 22-.2 23.5-.4 34.6-3.3 32.6-8.5 53.7-26.7 63-54.3 2.9-8.5 3.3-11 3.7-23.6.7-16.6-.8-25.3-6.3-36.3z"
  })), forbes_path3 || (forbes_path3 = /*#__PURE__*/react.createElement("path", {
    className: "forbes_svg__st0",
    d: "M864.3 104.4c-5.9-1.2-11.2-1.5-22.7-1.1-17.2.6-29.1 3.2-42 9.1-4.3 2-8 3.6-8.3 3.6-.3 0-.2-26.1.1-58 .5-44.9.3-58-.6-58-3.3-.1-105.4 19.4-106.5 20.3-.8.7-1.2 2.8-1 6.1.3 5.7-.3 5.2 12.1 8 3.7.8 8.1 2.5 9.7 3.6 4.2 3 7.6 9.4 10 18.5 1.9 7.2 2.1 12.4 3 61.4.9 50 .7 101.4-.7 195.6l-.6 39.1 7.3 1.7c10.6 2.4 40.9 7.5 50.8 8.5 14.6 1.5 48.5 1.3 59.3-.4 46.9-7.1 82.2-34.3 98.7-76 4.4-11 8.6-28.1 10-40.7 1.7-14.8.8-44.4-1.8-56.3-9.8-45.5-38.3-77.1-76.8-85zm2.5 158.1c-4.6 29.1-13 51.6-24.6 66.2-5.6 7-15 13.7-22.4 15.9-4.7 1.4-14.9 1.7-23.9.8-2-.2-4.2-1-4.8-1.7-1.7-2.1-3.6-137.8-2.4-177.5l.9-31.5 8-2.3c11.8-3.4 24.5-2.9 33.5 1.4 18.1 8.6 30 29.8 36.1 64.4 2.1 11.1 1.8 50.3-.4 64.3zm319.3-62c-4.6-44.9-22.8-75.9-53.7-91.4-27.5-13.8-69.9-12.8-100.9 2.4-29.4 14.3-49.6 38.2-60.9 72-5.9 17.6-7.7 31.7-7.1 54.5.4 14.4 1 21.9 2.5 28.5 11.6 51.7 47.1 86.9 96.7 95.9 10.9 2 35.7 2 46.8.1 15.8-2.8 33.9-9.8 45.4-17.5 14-9.5 28.3-23.7 28.3-28.1 0-2.7-4.8-8.9-6.9-8.9-.9 0-4.8 2-8.6 4.5-13.7 8.8-26.8 12.5-45 12.5-25.1 0-41-6.3-57-22.4-7.1-7.1-10-11-13.7-18.1-8.1-15.6-12.4-33.5-13.1-53.7l-.3-8.7 74-.3 74-.3.3-5c.2-2.7-.2-9.9-.8-16zm-83.1.9c-20.9 1.2-65.7 1.8-66.3.9-.8-1.2 1.1-19 3-28.2 4.5-22.2 11.6-38.3 21.4-48.2 5.3-5.3 7.7-7 12-8.2 3-.9 6.3-1.6 7.5-1.6 4.6 0 10 2.4 14 6.1 10.8 10 17 31.4 18.2 63.1l.6 15.6-10.4.5z"
  })));
};

/* harmony default export */ var forbes = (SvgForbes);
;// CONCATENATED MODULE: ./src/components/About/logos/reuters.svg
var _g, reuters_path;

function reuters_extends() { reuters_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return reuters_extends.apply(this, arguments); }



var SvgReuters = function SvgReuters(props) {
  return /*#__PURE__*/react.createElement("svg", reuters_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 247",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -735.35 72.156)"
  }, /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("path", {
    id: "reuters_svg__a",
    d: "M115.7-272h1674v512h-1674z"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "reuters_svg__b"
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#reuters_svg__a",
    overflow: "visible"
  })), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#reuters_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    className: "reuters_svg__st1",
    d: "M1194.308-58.358c0-9.9.4-10.2 9.3-10.2h29.9c1.3 0 2.3-1.1 2.3-2.3v-7.6c0-1.7-.6-2.3-2.3-2.5-3.8-.6-11.5-1.7-25.6-1.7-19.7 0-30.1-.1-30.1 24.2v37.4c0 24.4 10.4 24.2 30.1 24.2 14 0 21.7-1.1 25.6-1.6 1.8-.2 2.3-.8 2.3-2.5v-7.5c0-1.3-1.1-2.4-2.3-2.4h-30c-9 0-9.3-.3-9.3-10.2v-10.8h37.8c1.3 0 2.3-1.1 2.3-2.4v-8.5c0-1.3-1-2.4-2.3-2.4h-37.8l.1-13.2zm174.9-24.2c-10.5 0-21 1.8-26.7 3.1-1.2.2-2.2 1.1-2.2 2.4v8.5c0 1.3 1.1 2.2 2.2 2.2h.2c4.7-.6 15.8-2.1 26.7-2.1 10.5 0 13.7 3.8 13.7 10.6 0 8.9-21.2 13.8-31.5 18-10.3 4.3-13.9 12.4-13.9 20.7 0 13 10.5 22.5 32.5 22.5 11.3 0 21.6-2.1 25.6-3.1 1.2-.2 2.1-1.1 2.1-2.2v-8.8c0-1.2-.8-2.1-2-2.1h-.2c-7.8.7-15.9 2.1-26.2 2.1-8.8 0-15.3-3.1-15.3-8.4 0-3.9 4.5-7.5 9.7-9.5 5.2-2.1 12.1-4.8 20-7.9 9.9-4 16.4-9.9 16.4-21.2 0-12.1-7.5-24.8-31.1-24.8m-62.9 59.2c0 8.9-6.9 12.6-18.7 12.6-2.5 0-13.2-.2-15.4-.5v-25.6c1.9-.1 13.4-.4 15.4-.4 12.2 0 18.7 2.3 18.7 12.7v1.2zm17.7-58.2h-14.5c-1.3 0-1.8 1.2-2.3 2.4l-17 28.7h-2.6c-3.1 0-12.6.3-15.4.5v-29.1c0-1.3-.9-2.4-2.2-2.4h-11.8c-1.3 0-2.4 1.1-2.4 2.4v77.5c0 2.4 1.4 3.2 3.8 3.6 6.2.9 19.4 1.5 28 1.5 18.2 0 35-6.5 35-26.7v-1.3c0-12.5-6.3-19.4-16-23.1l18.6-31.6c.2-.4.2-.7.2-1 .1-.8-.4-1.4-1.4-1.4m-160.5 70.2h-23.6v-67.9c0-1.3-1.1-2.4-2.4-2.4h-11.7c-1.3 0-2.4 1.1-2.4 2.4v67.9h-23.6c-1.3 0-2.4.8-2.4 2.1v9.3c0 1.3 1.1 2.3 2.4 2.3h63.7c1.3 0 2.4-.9 2.4-2.3v-9.3c-.1-1.3-1.1-2.1-2.4-2.1m-113.2-71.2c-19 0-35.4 8.3-35.4 33.5v49.2c0 1.3 1.1 2.3 2.4 2.3h11.7c1.3 0 2.4-.9 2.4-2.3v-49.2c0-13.5 6.2-19.9 19-19.9s19 6.4 19 19.9v49.2c0 1.3 1.1 2.3 2.4 2.3h11.7c1.3 0 2.4-.9 2.4-2.3v-49.2c-.2-25.2-16.5-33.5-35.6-33.5m-94.7 24.2c0-9.9.4-10.2 9.3-10.2h29.9c1.3 0 2.4-1.1 2.4-2.3v-7.6c0-1.7-.6-2.3-2.4-2.5-3.8-.6-11.5-1.7-25.6-1.7-19.6 0-30-.1-30 24.2v37.4c0 24.4 10.4 24.2 30 24.2 14.1 0 21.8-1.1 25.6-1.6 1.8-.2 2.4-.8 2.4-2.5v-7.5c0-1.3-1.1-2.4-2.4-2.4h-29.9c-8.9 0-9.3-.3-9.3-10.2v-10.8h37.8c1.3 0 2.4-1.1 2.4-2.4v-8.5c0-1.3-1.1-2.4-2.4-2.4h-37.8v-13.2zm-50.7 35c0 8.9-6.9 12.6-18.7 12.6-2.5 0-13.3-.2-15.4-.5v-25.6c1.9-.1 13.3-.4 15.4-.4 12.2 0 18.7 2.3 18.7 12.7v1.2zm17.8-58.2h-14.4c-1.3 0-1.8 1.2-2.4 2.4l-17 28.7h-2.6c-3.1 0-12.6.3-15.4.5v-29.1c0-1.3-1-2.4-2.3-2.4h-11.8c-1.3 0-2.4 1.1-2.4 2.4v77.5c0 2.4 1.4 3.2 3.8 3.6 6.2.9 19.4 1.5 28 1.5 18.2 0 35-6.5 35-26.7v-1.3c0-12.5-6.3-19.4-16-23.1l18.6-31.6c.2-.4.2-.7.2-1 .1-.8-.4-1.4-1.3-1.4"
  })))), reuters_path || (reuters_path = /*#__PURE__*/react.createElement("path", {
    className: "reuters_svg__st1",
    d: "M121.4 82.656c-2.125 1.125-2.875 3.75-1.75 5.75 1.125 2.125 3.75 2.875 5.875 1.75s2.875-3.75 1.75-5.875c-.75-1.375-2.25-2.25-3.75-2.25-.75.125-1.375.25-2.125.625m11.625.125c-1.875 1-2.5 3.25-1.5 5.125s3.25 2.5 5.125 1.5 2.5-3.375 1.5-5.125c-.625-1.25-2-2-3.375-2-.625 0-1.25.25-1.75.5m-22.5 3.125c-2.375 1.25-3.25 4.25-2 6.625s4.25 3.25 6.625 2 3.25-4.25 2-6.625c-.875-1.625-2.5-2.625-4.25-2.625-.875 0-1.625.25-2.375.625m33.5.5c-1.625.875-2.25 3-1.375 4.5.875 1.625 2.875 2.25 4.5 1.375s2.25-2.875 1.375-4.5c-.625-1.125-1.75-1.75-3-1.75-.5 0-1 .125-1.5.375m-42.25 6.875c-2.125 1.125-2.875 3.75-1.75 5.875 1.125 2 3.75 2.875 5.75 1.75 2.125-1.125 2.875-3.75 1.75-5.75-.75-1.375-2.25-2.25-3.75-2.25-.625-.25-1.375 0-2 .375m51.75 0c-1.375.75-1.875 2.5-1.25 3.875.75 1.375 2.5 1.875 3.875 1.25 1.375-.75 1.875-2.5 1.125-3.875-.5-1-1.5-1.5-2.5-1.5-.25-.125-.75 0-1.25.25m7.125 9.375c-1.125.625-1.625 2.125-.875 3.25.625 1.125 2.125 1.625 3.25 1s1.625-2 1-3.25c-.5-.875-1.25-1.25-2.125-1.25-.5 0-.875.125-1.25.25m-65 .375c-1.875 1-2.5 3.375-1.625 5.125 1 1.875 3.375 2.5 5.125 1.5 1.875-1 2.625-3.25 1.5-5.125-.75-1.25-2-2-3.375-2-.5 0-1.125.125-1.625.5m68.5 9.875c-1.375.75-1.875 2.5-1.125 3.875s2.5 1.875 3.875 1.25c1.375-.875 2-2.5 1.25-3.875-.5-1-1.5-1.5-2.5-1.5-.625-.125-1 0-1.5.25m-71.625 1.375c-1.625.875-2.25 2.875-1.375 4.5s2.875 2.25 4.5 1.375 2.25-2.875 1.375-4.5c-.625-1.125-1.75-1.75-2.875-1.75-.5-.125-1 0-1.625.375m71.75 9.5c-1.625.875-2.25 2.875-1.375 4.5s3 2.25 4.625 1.375 2.25-2.875 1.375-4.5c-.625-1.125-1.75-1.75-2.875-1.75-.75 0-1.25.125-1.75.375m-71.25 2.125c-1.375.75-1.875 2.5-1.125 3.875s2.5 1.875 3.875 1.125 2-2.5 1.125-3.875c-.5-1-1.5-1.5-2.5-1.5-.375.125-.875.125-1.375.375m67.75 8.375c-1.875 1-2.5 3.375-1.5 5.25s3.375 2.5 5.125 1.5c1.875-1 2.5-3.375 1.625-5.25-.625-1.25-2-2-3.375-2-.75 0-1.375.125-1.875.5m-63.75 2.75c-1.125.625-1.625 2.125-1 3.25s2 1.625 3.25 1c1.125-.625 1.625-2.125 1-3.25-.375-.75-1.25-1.25-2.125-1.25-.375 0-.75 0-1.125.25m57.125 6.125c-2.125 1.125-2.875 3.75-1.75 5.875s3.75 2.875 5.875 1.75 2.875-3.75 1.75-5.75c-.75-1.5-2.25-2.25-3.75-2.25-.875-.25-1.5 0-2.125.375m-50.5 2.5c-1.375.75-1.875 2.5-1.125 3.875s2.5 1.875 3.875 1.125 1.875-2.5 1.125-3.875c-.5-1-1.5-1.5-2.5-1.5-.375 0-.875.125-1.375.375m41.125 3.875c-2.375 1.25-3.25 4.25-2 6.625s4.25 3.25 6.625 2 3.25-4.25 2-6.625c-.875-1.625-2.5-2.625-4.25-2.625-.75 0-1.625.125-2.375.625m-32 2.125c-1.625.875-2.25 2.875-1.375 4.5s2.875 2.25 4.5 1.375 2.25-3 1.375-4.625c-.625-1.125-1.75-1.75-3-1.75-.5 0-1 .125-1.5.5m21.625 2.125c-2.125 1.125-2.875 3.75-1.625 5.875 1.125 2.125 3.75 2.875 5.75 1.75 2.125-1.125 2.875-3.75 1.75-5.75-.75-1.5-2.25-2.25-3.75-2.25-.75-.125-1.5 0-2.125.375m-11 .625c-1.875 1-2.5 3.375-1.5 5.125 1 1.875 3.375 2.625 5.25 1.5 1.875-1 2.5-3.375 1.5-5.25-.625-1.25-2-2-3.375-2a6.588 6.588 0 0 0-1.875.625M123.275 70.906c-.875 2.875.75 5.875 3.75 6.75 2.875.875 5.875-.875 6.75-3.75s-.75-6-3.625-6.75c-.5-.125-1-.25-1.5-.25-2.5.125-4.625 1.625-5.375 4m14.625 1.75c-1 3.375.875 6.75 4.25 7.75s6.75-.875 7.75-4.25-.875-6.875-4.25-7.875c-.625-.125-1.125-.25-1.75-.25-2.625.125-5.125 1.875-6 4.625m-29.25 1.25c-.75 2.625.75 5.25 3.375 6 2.5.75 5.25-.75 6-3.25s-.75-5.25-3.25-6c-.5-.125-.875-.125-1.375-.125-2.125 0-4.125 1.375-4.75 3.375m44.125 5.625c-.875 2.875.875 5.875 3.75 6.75s5.875-.875 6.75-3.75-.75-5.875-3.75-6.75c-.5-.125-1-.25-1.5-.25-2.375.125-4.625 1.625-5.25 4m-56.75 2.125c-.625 2 .5 4.125 2.625 4.75 2 .625 4.125-.625 4.75-2.625s-.625-4.125-2.625-4.75c-.375-.125-.75-.125-1.125-.125-1.625 0-3.125 1.125-3.625 2.75m68.5 8.75a4.841 4.841 0 0 0 3.25 6c2.625.75 5.25-.75 6-3.25s-.75-5.25-3.25-6c-.5-.125-.875-.25-1.375-.25-2 0-3.875 1.375-4.625 3.5m-78.375 2.75c-.5 1.625.5 3.375 2.125 3.75 1.625.5 3.375-.5 3.875-2.125s-.5-3.375-2.125-3.875c-.25-.125-.625-.125-.875-.125-1.375.125-2.625 1-3 2.375m86.875 11.125c-.625 2 .625 4.125 2.625 4.75s4.125-.625 4.75-2.625-.5-4.125-2.625-4.75c-.375-.125-.75-.125-1.125-.125-1.625 0-3.25 1.125-3.625 2.75m-92.75 3.125c-.375 1.25.25 2.5 1.5 2.875s2.5-.375 2.875-1.625-.375-2.5-1.625-2.875c-.25 0-.375-.125-.625-.125-1 .125-1.875.75-2.125 1.75m96.25 12.375c-.5 1.625.375 3.375 2.125 3.875 1.625.5 3.375-.5 3.875-2.125s-.375-3.375-2.125-3.875c-.25-.125-.625-.125-.875-.125-1.375 0-2.625.875-3 2.25m-99.125 2.75c-.5 1.625.5 3.375 2.125 3.875s3.375-.375 3.875-2.125c.5-1.625-.5-3.375-2.125-3.875-.25-.125-.625-.125-.875-.125-1.25 0-2.5.875-3 2.25m97.875 12.75c-.375 1.25.375 2.5 1.5 2.875 1.25.375 2.5-.375 2.875-1.625s-.25-2.5-1.5-2.875c-.25 0-.375-.125-.625-.125-1 .125-1.875.75-2.25 1.75m-95.625 2.25c-.625 2 .5 4.125 2.625 4.75 2 .625 4.125-.625 4.75-2.625s-.625-4.125-2.625-4.75c-.375-.125-.75-.125-1.125-.125-1.625 0-3.125 1.125-3.625 2.75m88.25 11.625c-.5 1.625.5 3.375 2.125 3.875s3.375-.5 3.875-2.125-.5-3.375-2.125-3.875c-.25-.125-.625-.125-.875-.125-1.375 0-2.5.875-3 2.25m-81.875 1.75c-.75 2.5.75 5.25 3.25 6 2.625.75 5.25-.75 6-3.25s-.75-5.25-3.375-6c-.5-.125-.875-.25-1.375-.25-1.875 0-3.75 1.375-4.5 3.5m70.5 9.25c-.625 2 .625 4.125 2.625 4.75s4.125-.5 4.75-2.625c.625-2-.5-4.125-2.5-4.75-.375-.125-.75-.125-1.125-.125a3.901 3.901 0 0 0-3.75 2.75m-59.75 1.25c-.875 2.875.75 5.875 3.75 6.75 2.875.875 5.875-.875 6.75-3.625.875-2.875-.875-5.875-3.75-6.75-.5-.125-1-.25-1.5-.25-2.375-.125-4.5 1.5-5.25 3.875m13.25 6.375c-1 3.375.875 6.75 4.25 7.75s6.875-1 7.75-4.25c1-3.375-.875-6.875-4.25-7.75-.625-.125-1.125-.25-1.75-.25-2.75 0-5.25 1.75-6 4.5m31.875-.5a4.841 4.841 0 0 0 3.25 6c2.625.75 5.25-.75 6-3.25s-.75-5.25-3.25-6c-.5-.125-.875-.25-1.375-.25-2 0-4 1.375-4.625 3.5m-15.75 2.75c-.875 2.875.875 5.875 3.75 6.75s6-.75 6.75-3.625c.875-2.875-.75-6-3.75-6.75-.5-.125-1-.25-1.5-.25-2.375-.125-4.5 1.5-5.25 3.875M133.775 52.156c-2.375 2.5-2.25 6.5.25 8.75 2.5 2.375 6.5 2.25 8.75-.25 2.375-2.5 2.25-6.375-.25-8.75a6.262 6.262 0 0 0-4.25-1.625c-1.625 0-3.25.625-4.5 1.875m-19.625 1.625c-1.875 2-1.75 5.125.25 7s5 1.75 6.875-.25 1.75-5.125-.25-6.875c-1-.875-2.125-1.375-3.375-1.375a3.968 3.968 0 0 0-3.5 1.5m39 3.625c-2.625 2.75-2.5 7.25.25 9.875s7.25 2.5 9.875-.25 2.5-7.25-.25-9.875c-1.375-1.25-3.125-1.875-4.75-1.875-2 0-3.75.75-5.125 2.125m-57.875 3.875c-1.5 1.625-1.375 4.125.125 5.625 1.75 1.5 4.25 1.5 5.75-.125s1.375-4.125-.125-5.625a3.878 3.878 0 0 0-2.75-1.125c-1.125 0-2.125.5-3 1.25m74.125 7.125c-3.125 3.25-2.875 8.25.25 11.375 3.25 3.125 8.375 2.875 11.375-.25 3-3.25 2.875-8.375-.375-11.375-1.5-1.5-3.5-2.25-5.5-2.25s-4.125.75-5.75 2.5m-89.625 6.25c-1.125 1.25-1.125 3 .125 4.125s3.125 1.125 4.125-.125c1.125-1.25 1-3.125-.125-4.125-.625-.5-1.375-.75-2-.75-.75 0-1.625.25-2.125.875m103 10.75c-2.625 2.75-2.5 7.25.25 9.875 2.875 2.625 7.25 2.5 9.875-.25 2.625-2.875 2.5-7.25-.25-9.875-1.375-1.25-3-1.875-4.75-1.875-1.875 0-3.75.75-5.125 2.125M67.4 91.031c-1.5 1.625-1.375 4.125.125 5.625 1.625 1.5 4.125 1.375 5.625-.125 1.5-1.625 1.375-4.125-.125-5.625a3.878 3.878 0 0 0-2.75-1.125c-1.125 0-2.125.5-2.875 1.25m122.875 14.375c-2.375 2.5-2.25 6.375.25 8.75s6.5 2.25 8.75-.25c2.375-2.5 2.25-6.375-.25-8.75-1.25-1.125-2.75-1.75-4.25-1.75-1.625.125-3.25.75-4.5 2M60.9 110.281c-1.875 2-1.75 5 .25 6.875s5 1.75 6.875-.25 1.75-5.125-.25-6.875c-1-.875-2.125-1.375-3.375-1.375s-2.5.625-3.5 1.625m131 16.75c-1.875 2-1.75 5 .25 6.875s5 1.75 6.875-.25 1.75-5-.25-6.875c-1-.875-2.125-1.375-3.375-1.375-1.25.125-2.5.625-3.5 1.625m-131.375 3c-2.375 2.5-2.25 6.5.25 8.75 2.5 2.375 6.5 2.25 8.75-.25 2.375-2.5 2.25-6.375-.25-8.75a6.262 6.262 0 0 0-4.25-1.625c-1.625-.125-3.25.5-4.5 1.875m126.25 17.5c-1.5 1.625-1.5 4.125.125 5.625s4.125 1.375 5.625-.25 1.375-4.125-.125-5.625c-.75-.75-1.75-1-2.75-1.125-1 .125-2 .5-2.875 1.375M66.9 148.906c-2.625 2.75-2.5 7.25.25 9.875 2.875 2.625 7.25 2.5 9.875-.25s2.5-7.25-.25-9.875c-1.375-1.25-3.125-1.875-4.75-1.875-1.875 0-3.75.75-5.125 2.125m11.875 15.625c-3 3.25-2.875 8.25.375 11.375 3.25 3 8.375 2.875 11.375-.375s2.875-8.25-.375-11.375c-1.5-1.5-3.5-2.25-5.5-2.25-2.125.125-4.25 1-5.875 2.625m97.125.75c-1.125 1.125-1 3 .125 4.125 1.25 1.125 3.125 1 4.125-.125a2.836 2.836 0 0 0-.125-4.125c-.625-.5-1.25-.875-2-.875s-1.5.375-2.125 1m-79.25 11.625c-2.625 2.75-2.5 7.25.25 9.875s7.25 2.5 9.875-.25 2.5-7.25-.25-9.875c-1.375-1.25-3.125-1.875-4.75-1.875-1.875 0-3.75.75-5.125 2.125m62.125.25c-1.5 1.625-1.5 4.125.125 5.625s4.125 1.375 5.625-.125c1.5-1.625 1.5-4.125-.125-5.625a3.878 3.878 0 0 0-2.75-1.125c-1 .125-2 .5-2.875 1.25m-41.75 6.125c-2.375 2.5-2.25 6.5.25 8.75 2.5 2.375 6.5 2.25 8.75-.25 2.375-2.5 2.25-6.5-.25-8.75-1.25-1.125-2.75-1.75-4.25-1.75-1.625 0-3.25.625-4.5 2m21.625.25c-1.875 2-1.75 5 .25 6.875s5.125 1.75 6.875-.25c1.875-2 1.75-5.125-.25-6.875-1-.875-2.125-1.375-3.375-1.375-1.25.125-2.5.625-3.5 1.625M139.025 30.281c-2.875.625-4.75 3.375-4.25 6.375.625 2.875 3.375 4.75 6.375 4.25 2.875-.625 4.75-3.375 4.25-6.375a5.34 5.34 0 0 0-5.25-4.375c-.375 0-.75 0-1.125.125m-22.25 1.375c-2.25.375-3.875 2.5-3.5 4.75s2.5 3.875 4.75 3.5 3.875-2.5 3.5-4.75c-.25-2.125-2.125-3.625-4.125-3.625-.25.125-.5.125-.625.125m43.75 3.125c-3.5.875-5.625 4.375-4.75 7.875s4.5 5.625 7.875 4.75c3.5-.875 5.625-4.5 4.75-7.875-.75-3-3.375-4.875-6.25-4.875-.5-.125-1.125 0-1.625.125M93.9 38.406c-2 .875-2.875 3.125-2 5.125s3.125 2.875 5.125 2 2.875-3.125 2-5.125c-.625-1.5-2.125-2.375-3.625-2.375-.375.125-1 .25-1.5.375m85.625 6c-4.25 1.375-6.625 5.875-5.375 10.125 1.375 4.25 5.875 6.625 10.125 5.375 4.25-1.375 6.625-5.875 5.375-10.125-1.125-3.5-4.25-5.75-7.75-5.75-.75 0-1.5.125-2.375.375m-106.125 6c-1.875 1.375-2.125 4.125-.625 5.875 1.5 1.875 4.125 2.125 5.875.75 1.875-1.5 2.125-4.125.75-5.875-.875-1-2-1.625-3.25-1.625-1.125 0-2 .25-2.75.875m121.75 9.125c-4.625 1.75-7 6.875-5.25 11.5s6.875 7 11.5 5.25 7-6.875 5.25-11.5c-1.375-3.625-4.75-5.875-8.375-5.875-1 .125-2.125.25-3.125.625M57.025 65.656c-2.375 1.75-3 5-1.25 7.5 1.75 2.375 5.125 3 7.5 1.25s3-5.125 1.25-7.5c-1.125-1.5-2.75-2.25-4.375-2.25-1.125 0-2.125.25-3.125 1m149 12.875c-5 2.125-7.25 7.875-5.125 12.75s7.875 7.25 12.75 5.125c5-2.125 7.25-7.875 5.125-12.75-1.625-3.625-5.125-5.875-9-5.875-1.125 0-2.5.25-3.75.75m-160.5 5.75c-3 1.875-4 6-2 9 1.875 3 6 4 9 2 3-1.875 4-6 2-9-1.25-2-3.375-3-5.5-3-1.125 0-2.375.375-3.5 1m166.625 17.125c-4.375 2.25-6.25 7.625-4 12 2.25 4.5 7.625 6.25 12 4s6.25-7.5 4-12c-1.5-3.125-4.75-5-8-5-1.375 0-2.75.375-4 1m-172.625 3.375c-3.875 2.25-5.25 7.125-3.125 11 2.25 3.875 7.125 5.25 11 3.125 3.875-2.25 5.25-7.125 3.125-11a8.186 8.186 0 0 0-7.125-4.125c-1.25 0-2.625.25-3.875 1m172.875 20.25c-3.875 2.25-5.25 7.125-3.125 11 2.25 3.875 7.125 5.25 11 3.125 3.875-2.25 5.25-7.125 3.125-11a8.186 8.186 0 0 0-7.125-4.125c-1.25 0-2.625.25-3.875 1m-172.625 1.5c-4.375 2.125-6.25 7.5-4 12 2.25 4.375 7.625 6.25 12 4s6.25-7.5 4-12c-1.625-3.125-4.75-5-8-5-1.25.125-2.625.375-4 1m6.375 21c-5 2.125-7.25 7.875-5.125 12.75 2.125 5 7.875 7.25 12.75 5.125 5-2.125 7.25-7.875 5.125-12.75-1.625-3.75-5.125-5.875-9-5.875-1.125 0-2.5.25-3.75.75m161.25 1.125c-3 1.875-4 6-2 9 1.875 3 6 4 9 2 3-1.875 4-5.875 2-9-1.25-2-3.375-3-5.5-3-1.25 0-2.375.25-3.5 1m-148.875 19c-4.625 1.75-7 6.875-5.25 11.5s6.875 7 11.5 5.25 7-6.875 5.25-11.5c-1.375-3.625-4.75-5.875-8.375-5.875-1 0-2.125.25-3.125.625m138.125 2c-2.375 1.75-3 5.125-1.25 7.5s5.125 3 7.5 1.25 3-5.125 1.25-7.5c-1-1.5-2.75-2.25-4.375-2.25-1 0-2.125.25-3.125 1M75.525 184.031c-4.25 1.375-6.625 5.875-5.25 10.125s5.875 6.625 10.125 5.375c4.25-1.375 6.625-5.875 5.375-10.125-1.125-3.5-4.25-5.75-7.75-5.75-.875 0-1.625.125-2.5.375m105.875 3c-1.875 1.5-2.125 4.125-.625 5.875 1.5 1.875 4.125 2.125 5.875.75 1.875-1.5 2.125-4.125.625-5.875-.875-1-2-1.625-3.25-1.625-1-.125-1.875.25-2.625.875m-85.25 9.625c-3.5.875-5.625 4.375-4.75 7.875s4.375 5.625 7.875 4.75 5.625-4.375 4.75-7.875c-.75-3-3.375-4.875-6.25-4.875-.5-.125-1-.125-1.625.125m66.75 1.75c-2 .875-2.875 3.125-2 5.125s3.125 2.875 5.125 2 2.875-3.125 2-5.125c-.625-1.5-2.125-2.375-3.625-2.375-.5 0-1 .125-1.5.375m-44.125 4.75c-2.875.625-4.75 3.375-4.25 6.375.625 2.875 3.375 4.75 6.375 4.25 2.875-.625 4.75-3.375 4.25-6.375-.5-2.5-2.75-4.25-5.25-4.25h-1.125m23.125.875c-2.25.375-3.875 2.5-3.5 4.75s2.5 3.875 4.75 3.5 3.875-2.5 3.5-4.75c-.25-2.125-2.125-3.625-4.125-3.625-.125 0-.375 0-.625.125M124.9 10.531c0 2.75 2.25 5 5 5s5-2.25 5-5-2.25-5-5-5-5 2.125-5 5m28.75 2.375c-.75 2.875 1 5.875 3.75 6.625 2.875.75 5.875-.875 6.625-3.75s-1-5.875-3.875-6.625c-.5-.125-1-.25-1.375-.25-2.375 0-4.5 1.625-5.125 4m-54-3.75c-2.875.75-4.625 3.75-3.75 6.625.75 2.875 3.75 4.625 6.625 3.75 2.875-.75 4.625-3.75 3.875-6.625-.625-2.375-2.75-4-5.25-4-.5 0-1 0-1.5.25m79.375 14.75c-.75 3.75 1.625 7.375 5.25 8.125 3.75.75 7.375-1.625 8.125-5.25.75-3.75-1.625-7.375-5.25-8.125-.5-.125-1-.125-1.5-.125-3.125 0-6 2.25-6.625 5.375m-106.25-5.25c-3.75.75-6.125 4.375-5.25 8.125.75 3.75 4.5 6.125 8.125 5.25 3.75-.75 6.125-4.5 5.25-8.125-.625-3.25-3.5-5.375-6.75-5.375-.375 0-.875 0-1.375.125m127.75 23.125c-.75 4.5 2.375 8.875 6.875 9.5 4.5.75 8.875-2.375 9.5-7 .75-4.625-2.375-8.875-6.875-9.5-.5 0-.875-.125-1.375-.125-3.875.125-7.375 3-8.125 7.125m-150.75-6.875c-4.5.75-7.625 5-6.875 9.5s5 7.625 9.5 7c4.625-.75 7.625-5 7-9.5-.625-4.125-4.25-7-8.25-7a2.568 2.568 0 0 0-1.375 0m166.375 30.25c-.625 5.75 3.5 10.875 9.25 11.375 5.75.625 10.875-3.5 11.375-9.25.625-5.75-3.5-10.875-9.25-11.375H226.4c-5.125-.125-9.625 3.875-10.25 9.25m-183.875-9.25c-5.75.625-9.875 5.75-9.25 11.375.625 5.75 5.75 9.875 11.375 9.25 5.75-.625 9.875-5.75 9.25-11.375a10.413 10.413 0 0 0-10.375-9.25c-.25-.125-.625-.125-1 0m194 36.625a11.3 11.3 0 0 0 10.875 12c6.375.375 11.75-4.5 12.125-10.875a11.3 11.3 0 0 0-10.875-12h-.625c-6.125 0-11.25 4.75-11.5 10.875M21.65 81.656c-6.25.375-11.125 5.625-10.875 12 .375 6.375 5.75 11.25 12.125 10.875a11.534 11.534 0 0 0 10.875-12c-.375-6.125-5.375-10.875-11.5-10.875h-.625m207.375 40.375c0 6.875 5.625 12.5 12.5 12.5s12.5-5.625 12.5-12.5-5.625-12.5-12.5-12.5c-7 0-12.5 5.5-12.5 12.5m-223 0c0 6.875 5.625 12.5 12.5 12.5s12.5-5.625 12.5-12.5-5.625-12.5-12.5-12.5c-7 0-12.5 5.5-12.5 12.5m231 17.375c-6.25.375-11.125 5.75-10.875 12 .375 6.375 5.75 11.125 12.125 10.875 6.25-.375 11.125-5.625 10.875-12-.25-6.125-5.375-10.875-11.5-10.875h-.625m-226.25 10.875a11.3 11.3 0 0 0 10.875 12c6.375.375 11.75-4.5 12.125-10.875a11.3 11.3 0 0 0-10.875-12h-.625c-6.125 0-11.125 4.75-11.5 10.875M225.4 167.406c-5.75.625-9.875 5.75-9.25 11.5s5.75 9.875 11.5 9.25 9.875-5.75 9.25-11.375c-.625-5.375-5-9.25-10.375-9.25-.375-.25-.75-.125-1.125-.125m-202.375 9.25c-.625 5.75 3.5 10.875 9.25 11.375 5.75.625 10.875-3.5 11.375-9.25a10.41 10.41 0 0 0-9.25-11.5c-.375 0-.75-.125-1.125-.125-5.125.125-9.625 4.125-10.25 9.5m184.5 16c-4.5.75-7.625 5-6.875 9.5.75 4.625 5 7.625 9.5 7 4.5-.75 7.625-5 6.875-9.5-.625-4.125-4.25-7-8.25-7a2.13 2.13 0 0 0-1.25 0M42.9 199.531c-.75 4.625 2.375 8.875 6.875 9.5 4.625.75 8.875-2.375 9.625-7 .75-4.5-2.375-8.875-7-9.5-.375-.125-.875-.125-1.25-.125-4.125.125-7.625 3-8.25 7.125m141.375 12.25c-3.75.75-6.125 4.5-5.25 8.125.75 3.75 4.5 6.125 8.125 5.25 3.75-.75 6.125-4.5 5.25-8.25-.625-3.25-3.5-5.5-6.75-5.5-.375.25-.875.375-1.375.375M67.4 217.156c-.75 3.75 1.625 7.375 5.25 8.25 3.75.75 7.375-1.625 8.125-5.25.75-3.75-1.625-7.375-5.25-8.125-.5-.125-1-.125-1.375-.125-3.125-.25-6 2-6.75 5.25m90 7.375c-2.875.75-4.625 3.75-3.75 6.625.75 2.875 3.75 4.625 6.625 3.75 2.875-.75 4.625-3.75 3.875-6.625-.625-2.375-2.875-4-5.25-4-.5 0-1 .125-1.5.25m-61.5 3.75c-.75 2.875 1 5.75 3.75 6.625 2.875.75 5.875-.875 6.625-3.75s-1-5.875-3.875-6.625c-.5-.125-.875-.25-1.375-.25-2.25 0-4.5 1.625-5.125 4m29 5.25c0 2.75 2.25 5 5 5s5-2.25 5-5-2.25-5-5-5-5 2.25-5 5"
  })));
};

/* harmony default export */ var reuters = (SvgReuters);
;// CONCATENATED MODULE: ./src/components/About/logos/wired.svg
var wired_path, wired_path2, wired_path3;

function wired_extends() { wired_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wired_extends.apply(this, arguments); }



var SvgWired = function SvgWired(props) {
  return /*#__PURE__*/react.createElement("svg", wired_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401 82",
    xmlSpace: "preserve"
  }, props), wired_path || (wired_path = /*#__PURE__*/react.createElement("path", {
    className: "wired_svg__st0",
    d: "M0-.1v82h80.2v-82H0zM63.5 65c-.3 1.4-.4 3-1.8 3.9-3.8.5-7.7.5-11.5 0-1.3-.8-1.4-2.5-1.8-3.9-2.8-12.8-5.2-25.7-8.2-38.4-.5 1-.9 2.1-1 3.2-2.4 11.9-5 23.7-7.4 35.6-.3 1.4-.8 3.7-2.7 3.6-3.5.2-7.1.4-10.6-.2-1.9-1.3-1.5-4-2.2-6-3.6-16.6-6.8-33.4-10.4-50.1h11c2.3 15.2 4.9 30.3 7.6 45.4.5-1.1.8-2.3 1.1-3.5C28.2 41.8 31 29 33.7 16.2c.3-1.3.7-3.3 2.4-3.5 3-.2 5.9-.2 8.9 0 2.4 1.1 2.1 4.3 2.8 6.6 2.9 12.9 5.1 26 8.5 38.9 3-15.1 5.1-30.4 7.8-45.5h10.1C70.4 30.1 67.1 47.6 63.5 65zM159.8-.1v82H240v-82h-80.2zM213 69c-.4-6.1-.9-12.1-1.2-18.2.1-2.4-2.6-4-4.8-3.8h-18.1v22h-11.1V12.8h33.1c3.4 0 7.5.4 9.7 3.4 2.7 3.6 2.6 8.3 2.7 12.6 0 3.7-.2 7.7-2.6 10.7-1.6 2.2-4.5 2.3-6.8 3.5 3 .9 6.9 1.7 7.9 5.2 1.9 6.7.7 13.9 1.7 20.7-3.4.1-6.9.1-10.5.1zM319.8-.1v82H401v-82h-81.2zm62.1 62.7c-3.5 5.2-10.2 6.2-15.9 6.3-9.4.1-18.7 0-28 0V12.7c9.7 0 19.4-.1 29.1.1 5.4.2 11.6 1.5 14.8 6.3 4.1 6.5 3.4 14.5 4.2 21.8-.8 7.3-.2 15.2-4.2 21.7z"
  })), wired_path2 || (wired_path2 = /*#__PURE__*/react.createElement("path", {
    className: "wired_svg__st0",
    d: "M189 22c7.1.1 14.3-.2 21.4.1 2.8 1.9 2.2 5.9 2.3 8.8-.1 2.7-.2 7-3.8 7.2-6.6.3-13.3 0-20 .1.1-5.4.1-10.8.1-16.2zm160 .1h18.1c2.7 0 5.8 1.3 6.6 4 1.9 5.4 1.1 11.3 1.3 16.9-.2 4.5.3 9.2-1.6 13.4-1.3 2.7-4.6 3.4-7.3 3.4H349V22.1z"
  })), wired_path3 || (wired_path3 = /*#__PURE__*/react.createElement("path", {
    className: "wired_svg__st0",
    d: "M349 22v37.8h17.1c2.7 0 6-.7 7.3-3.4 1.9-4.2 1.4-9 1.6-13.4-.2-5.6.6-11.5-1.3-16.9-.9-2.8-3.9-4.1-6.6-4-6-.2-12.1-.1-18.1-.1zm-46.4 47.5h-48.2c-.1-3.3 0-6.7 0-10h7.6V22.3h-7.7v-10h47.5V31h-10.3v-8.6h-18.6v12.9h15v9.6h-15v14.7c6.4-.1 12.7 0 19.1 0v-9.8h10.5c.1 6.5.2 13.1.1 19.7zm-163.2-10v10.1h-38.8V59.5h13.7V22.3h-13.7V12.2h38.8v10.1h-13.7v37.2c4.6 0 9.1-.1 13.7 0z"
  })));
};

/* harmony default export */ var wired = (SvgWired);
;// CONCATENATED MODULE: ./src/components/About/logos/coindesk.svg
var coindesk_path, coindesk_path2;

function coindesk_extends() { coindesk_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return coindesk_extends.apply(this, arguments); }



var SvgCoindesk = function SvgCoindesk(props) {
  return /*#__PURE__*/react.createElement("svg", coindesk_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1331.7 317.8",
    xmlSpace: "preserve"
  }, props), coindesk_path || (coindesk_path = /*#__PURE__*/react.createElement("path", {
    d: "M272 40.1c1.4.5 2.8 1 4.2 1.3 11.5 3.2 20.6 13.6 21.6 24.9 1.3 13.7-4.9 25.3-16.4 31-11 5.4-25 3.9-33.4-5.1-12.7-13.7-32.4-13.3-45-.1-11.2 11.8-29.6 10.9-41.8-.9-8-7.8-17.2-11.2-28.2-8.5-17.9 4.4-33.5 28.4-16.9 49.1 4.8 6 9.8 11.8 10.7 19.9 1.1 10.2-2.1 18.8-9.2 26.4-15.8 16.9-8 44.1 14.3 50.4 11.5 3.3 21.3-.4 29.8-8.3 6.3-5.8 13.6-8.7 22.3-8.4 14.9.6 26.2 11 28.6 26.4 2.1 13.2-6.7 27.1-20 31.7-1.9.6-3.7 1.4-5.5 2h-8c-8.2-2.1-14.8-6.7-21.2-12.3-10.1-9-25.5-9-35.7-.1-6.4 5.6-12.9 10.3-21.1 12.4h-8c-1.2-.4-2.4-.9-3.6-1.3-9.7-3-16.6-9.1-20.2-18.8-.7-2-1.4-4-2.2-5.9v-8c2-8.5 6.9-15.1 12.5-21.6 8.7-10 8.6-25.3-.1-35.3-5.6-6.4-10.3-12.9-12.4-21.1v-8c2.2-8.2 6.8-14.8 12.4-21.1 8.9-10.1 8.8-25.4-.2-35.7-5.7-6.2-10.3-12.7-12.3-21v-8c.4-1.2.9-2.4 1.3-3.6 3-9.7 9-16.7 18.7-20.3 2-.7 4-1.4 5.9-2.1h8c8 2.1 14.5 6.5 20.8 11.9 10.1 8.7 24.7 8.7 35.4.4 6.7-5.2 13.3-10.3 21.8-12.3h8c8 2.3 14.4 6.9 20.7 12.2 10 8.4 24.5 8.4 35.1.1 6.6-5.1 13-10.2 21.2-12.3h8.1zm-14 202.3c0-6 4.5-10.3 10.4-10.2 5.5.1 10.1 4.7 10.2 10.1.1 5.6-4.7 10.5-10.4 10.5-5.8.1-10.2-4.4-10.2-10.4z"
  })), coindesk_path2 || (coindesk_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M258 158.3c.1-6 4.4-10.2 10.5-10.1 5.6.1 10.1 4.7 10.1 10.2 0 5.6-4.9 10.5-10.5 10.5-5.7-.1-10.1-4.8-10.1-10.6zm-65.1.9c0 5.9-4.5 10.4-10.3 10.3-5.7-.1-10.5-5-10.3-10.6.2-5.5 4.7-9.9 10.3-10 6-.1 10.4 4.3 10.3 10.3zm216 54.7c5.5 0 10.7-1.1 15.6-3.2 4.9-2.2 10.1-5.1 15.6-8.9l15.5 15.8c-8.1 6.7-15.8 11.3-23.1 13.8-7.3 2.5-15.2 3.7-23.6 3.7-9.5 0-18.3-1.7-26.4-5-8.1-3.4-15.1-7.9-21.1-13.7-5.9-5.8-10.6-12.6-14-20.4-3.4-7.8-5-16.2-5-25.2 0-9.5 1.7-18.3 5-26.5 3.4-8.2 8-15.3 14-21.3 5.9-6 13-10.7 21.1-14.1s16.9-5 26.4-5c8.3 0 16.2 1.4 23.8 4.1 7.6 2.8 15.2 7.2 23 13.4l-15.5 15.8c-5-3.4-10.1-6.3-15.2-8.7-5.2-2.3-10.5-3.5-16-3.5-6 0-11.8 1.2-17.3 3.6-5.5 2.4-10.3 5.7-14.5 9.9-4.1 4.2-7.4 9.1-9.8 14.6s-3.6 11.4-3.6 17.6c0 5.7 1.2 11.1 3.6 16.3s5.7 9.7 9.8 13.7c4.1 4 9 7.2 14.5 9.6 5.4 2.4 11.2 3.6 17.2 3.6zm115 21.2c-8.8 0-17.1-1.6-25.1-4.9-7.9-3.3-14.9-7.8-20.8-13.7s-10.7-12.8-14.2-20.8-5.3-16.7-5.3-26c0-8.8 1.8-17.2 5.3-25.2s8.3-15 14.2-21.1c5.9-6 12.9-10.8 20.8-14.3s16.3-5.3 25.1-5.3 17.2 1.8 25.2 5.3 15 8.3 21.1 14.3c6 6 10.8 13 14.3 21.1 3.5 8 5.3 16.4 5.3 25.2 0 9.3-1.8 18-5.3 26s-8.3 14.9-14.3 20.8-13.1 10.4-21.1 13.7c-8 3.2-16.4 4.9-25.2 4.9zm0-109.4c-6.4 0-12.2 1.2-17.4 3.6-5.3 2.4-9.8 5.6-13.7 9.7-3.9 4.1-6.9 8.7-9 14-2.2 5.3-3.2 10.8-3.2 16.7 0 6.2 1.1 12 3.2 17.3 2.2 5.3 5.2 9.9 9 13.8 3.9 3.9 8.4 6.9 13.7 9 5.3 2.2 11.1 3.2 17.4 3.2 6.4 0 12.2-1.1 17.6-3.2 5.3-2.2 9.9-5.2 13.8-9 3.9-3.9 6.9-8.5 9-13.8 2.2-5.3 3.2-11.1 3.2-17.3 0-5.9-1.1-11.4-3.2-16.7-2.2-5.3-5.1-9.9-8.9-14-3.8-4-8.4-7.3-13.8-9.7s-11.3-3.6-17.7-3.6zM627 65v22h-22.7V65H627zm-22.7 39.5H627v129.2h-22.7V104.5zM671.5 234h-22.7V104.8h22.7l.3 15.5c1-1.6 2.5-3.4 4.5-5.4 2-2.1 4.3-4 7-5.8s5.8-3.4 9.4-4.7c3.6-1.3 7.7-1.9 12.1-1.9 9.3 0 17.3 1.8 23.9 5.3 6.6 3.5 12.1 8.3 16.3 14.2 4.2 5.9 7.3 12.8 9.3 20.7 2 7.8 3 16 3 24.4V234h-23v-67.4c0-4.7-.4-9.5-1.2-14.5s-2.2-9.5-4.4-13.6c-2.2-4-5.1-7.4-8.9-10.1-3.8-2.7-8.8-4-15-4-5.5 0-10.3 1.1-14.5 3.4-4.1 2.2-7.6 5.3-10.5 9-2.8 3.8-5 8.2-6.3 13.3-1.4 5.1-2.1 10.5-2.1 16.2V234h.1zm160.7-128.9c6.4 0 12.2 1 17.4 3 5.3 2 9.8 4.2 13.6 6.6 4.5 2.8 8.4 5.9 11.9 9.3V41.5h23v192.8h-23v-19.6c-1.2 1.7-2.9 3.8-5.2 6.2-2.2 2.4-5.1 4.7-8.7 7-3.5 2.2-7.7 4.2-12.5 5.8s-10.3 2.5-16.5 2.5c-9.3 0-17.7-1.8-25.2-5.4-7.5-3.6-13.9-8.5-19.3-14.6-5.3-6.1-9.4-13.2-12.3-21.2-2.8-8-4.3-16.4-4.3-25.2 0-8.4 1.4-16.6 4.3-24.4 2.8-7.8 6.9-14.7 12.3-20.7 5.3-5.9 11.8-10.7 19.3-14.2 7.5-3.7 15.9-5.4 25.2-5.4zm0 109.5c5.3 0 10.6-.9 15.6-2.8 5.1-1.9 9.6-4.7 13.7-8.4 4-3.7 7.3-8.4 9.8-14.1 2.5-5.7 3.7-12.3 3.7-19.9 0-7.1-1.2-13.3-3.6-18.6-2.4-5.3-5.6-9.8-9.6-13.3s-8.5-6.2-13.7-8c-5.2-1.8-10.5-2.7-16-2.7-6.2 0-11.7 1.3-16.4 4s-8.7 6.1-11.8 10.2c-3.1 4.1-5.5 8.7-7.1 13.7s-2.5 9.8-2.5 14.5c0 5 .7 10.2 2.2 15.5s3.7 10.2 6.8 14.6c3.1 4.4 7 8.1 11.8 11 4.9 2.9 10.6 4.3 17.1 4.3zm197.4-5.6c-6.9 8.3-14.7 14.7-23.5 19.4s-18.6 7-29.5 7c-10.2 0-19.1-1.6-26.7-4.9-7.7-3.3-14.1-7.8-19.3-13.6s-9-12.6-11.6-20.5-3.9-16.5-3.9-25.8c0-8.8 1.3-17.1 3.9-25.1 2.6-7.9 6.5-14.9 11.6-20.9 5.2-6 11.6-10.8 19.3-14.3s16.6-5.3 26.7-5.3c9.3 0 17.7 1.8 25.3 5.4s14 8.6 19.3 15c5.3 6.4 9.3 14 12.3 22.7 2.9 8.8 4.4 18.3 4.4 28.4H937.7c.2 5.7 1.1 10.9 2.8 15.6 1.7 4.7 4.2 8.8 7.5 12.3 3.3 3.4 7.3 6.2 12.1 8.1 4.8 2 10.3 3 16.5 3 6 0 11.5-1.1 16.3-3.2 4.8-2.2 8.9-4.6 12.1-7.4 3.8-3.1 7.1-6.6 10.1-10.6l14.5 14.7zm-53.2-83.8c-5.5 0-10.5.9-14.9 2.7s-8.2 4.2-11.5 7.1c-3.3 2.9-5.9 6.3-7.9 10.1s-3.2 7.7-3.7 11.6h74.7c-1-4.3-2.7-8.4-4.9-12.3-2.2-3.9-5-7.2-8.1-10.1-3.2-2.8-6.8-5.1-10.7-6.7-4-1.6-8.3-2.4-13-2.4zm93.6 13.2c0 2.1.7 4 2.2 5.9s3.4 3.7 5.8 5.3 5.3 3.3 8.5 4.9c3.3 1.6 6.6 3.2 10.1 4.8 4.7 2.1 9.4 4.4 14.3 6.8 4.9 2.5 9.3 5.3 13.3 8.4 4 3.1 7.2 6.7 9.7 10.9 2.5 4.1 3.7 8.9 3.7 14.2 0 10.5-4 19.1-12.1 25.8s-19.3 10.1-33.6 10.1c-7.2 0-13.8-.8-19.8-2.3-5.9-1.6-11.1-3.3-15.4-5.3s-7.6-3.8-9.8-5.4c-2.2-1.6-3.4-2.5-3.4-2.7l9-17.3c2.1 1 4.7 2.2 7.8 3.6 3.1 1.4 6.4 2.6 9.9 3.7s7.1 2.1 10.9 3c3.7.9 7.3 1.3 10.7 1.3 6 0 10.9-1.2 14.7-3.6 3.8-2.4 5.7-6 5.7-10.9 0-4.1-2.3-7.5-7-10.2s-10.3-5.5-16.8-8.4l-3.4-1.8v.3c-4.5-2.1-8.9-4.2-13.3-6.5-4.4-2.2-8.4-5-12-8.1-3.6-3.2-6.5-7-8.8-11.4-2.2-4.4-3.4-9.8-3.4-16.2 0-10.2 3.7-18.4 11-24.7 7.3-6.3 17.6-9.4 30.9-9.4 5.7 0 10.9.6 15.5 1.7 4.7 1.1 8.7 2.4 12.1 3.7 4 1.6 7.6 3.3 10.9 5.2l-9.6 18.1c-3.1-1.5-7.3-3.2-12.7-5-5.3-1.8-10.8-2.7-16.3-2.7-6 0-10.8 1.4-14.3 4.1-3.3 2.8-5 6.1-5 10.1zm75.9-96.9h22.7V234h-22.7V41.5zm123.8 192.8h-33.1l-70.8-71.1 57.9-57.9h32.8l-57.9 57.9 71.1 71.1z"
  })));
};

/* harmony default export */ var coindesk = (SvgCoindesk);
;// CONCATENATED MODULE: ./src/components/About/logos/fortune.svg
var fortune_path;

function fortune_extends() { fortune_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fortune_extends.apply(this, arguments); }



var SvgFortune = function SvgFortune(props) {
  return /*#__PURE__*/react.createElement("svg", fortune_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.3 130.6"
  }, props), fortune_path || (fortune_path = /*#__PURE__*/react.createElement("path", {
    d: "M72.9 29.8v71c0 16.5 13.3 29.8 30.4 29.8 16.5 0 29.8-13.3 29.8-29.8v-71c0-16.5-13.3-29.8-29.8-29.8-17.1 0-30.4 13.3-30.4 29.8m21.5 71v-71c0-5.1 3.8-8.2 8.9-8.2 4.4 0 8.2 3.2 8.2 8.2v71c0 4.4-3.8 8.2-8.2 8.2-5.1 0-8.9-3.8-8.9-8.2M306.8 1.3h-60.9v21.5h19.7v105.9h21.5V22.8h19.7zm63.4 0v99.5c0 4.4-3.8 8.2-8.2 8.2s-8.2-3.8-8.2-8.2V1.3h-22.2v99.5c0 16.5 13.9 29.8 30.4 29.8s30.4-13.3 30.4-29.8V1.3h-22.2zm197.1 21.5V1.3h-53.2v127.4h53.2v-21.6h-31.7V74.2h20.3V52.6h-20.3V22.8zM225.6 128.7h-22.8L187 68.5s13.9-2.5 13.9-17.1V31.7c0-5.1-3.8-8.9-8.9-8.9h-8.2v105.8h-21.6V1.3H192c16.5 0 29.8 12.7 30.4 29.2v20.3c0 12.7-4.4 21.5-12 27.9l15.2 50zM465.9 1.3V71L443.7 1.3h-22.2v127.4h22.2V66.6l20.3 62.1h24.1V1.3zM22.8 3.2H0v127.4h22.8V76.1h20.9V54.5H22.8V24.7h33V3.2z"
  })));
};

/* harmony default export */ var fortune = (SvgFortune);
;// CONCATENATED MODULE: ./src/components/About/AboutAsSeenIn.tsx









const AboutAsSeenIn = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        mt: {
            base: 20,
            md: "24 !important"
        },
        maxW: {
            base: "100%",
            lg: "90%",
            "2xl": "65%"
        },
        mx: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            gap: 8,
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                    size: "md",
                    children: "AS SEEN IN:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(cnn, {
                    height: "min(30px, 6vw)",
                    fill: "#8a939b"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(forbes, {
                    height: "min(30px, 6vw)",
                    fill: "#8a939b"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(reuters, {
                    height: "min(30px, 6vw)",
                    fill: "#8a939b"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(wired, {
                    height: "min(30px, 6vw)",
                    fill: "#8a939b"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(coindesk, {
                    height: "min(30px, 6vw)",
                    fill: "#8a939b"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(fortune, {
                    height: "min(30px, 6vw)",
                    fill: "#8a939b"
                })
            ]
        })
    });
/* harmony default export */ var About_AboutAsSeenIn = (AboutAsSeenIn);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/data/MeetOurTeamData.ts
const TeamData = [
    {
        image: "/images/team/navin.png",
        name: "Navin Vethanayagam",
        title: "Chief Brain",
        about: "Navin first joined IQ.wiki formerly Everipedia as a founding team member at the age of 19, gaining experience over the years in community management, marketing, press, and international business. Navin has an HBA from Ivey Business School.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/navin-vethanayagam",
            twitter: "https://twitter.com/NavV96"
        }
    },
    {
        image: "/images/team/ted.png",
        name: "Theodor Forselius",
        title: "Co-founder",
        about: "Theodor Forselius is a Swedish entrepreneur and programmer. He co-founded IQ.wiki at the age of 19. He currently serves as CEO of Brainfund which aims to advance the development of technologies in the education, AI and fintech sector. Brainfund is also the parent company of IQ.wiki.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/theodor-forselius",
            twitter: "https://twitter.com/TeddeF"
        }
    },
    {
        image: "/images/team/travis.png",
        name: "Travis Moore",
        title: "Co-founder",
        about: "Travis Moore is an Italian-American computer programmer, angel investor, and entrepreneur from Thousand Oaks, a suburb of Los Angeles. He co-founded IQ.wiki formerly Everipedia after graduating from UCLA with degrees in Molecular Biology, Biochemistry, and Neuroscience in 2011.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/travis-moore",
            twitter: "https://twitter.com/travismo123",
            linkedin: "https://www.linkedin.com/pub/travis-moore/5a/510/692"
        }
    },
    {
        image: "/images/team/sam.png",
        name: "Sam Kazemian",
        title: "Co-founder",
        about: "Sam Kazemian is an Iranian-American Internet entrepreneur and programmer. His journey in crypto started after he put together a homemade CPU + GPU mining rig in his UCLA dorm. His passion for the industry led him to integrate blockchain technology into an online knowledge base for the first time in history",
        socials: {
            iqWiki: "https://iq.wiki/wiki/sam-kazemian",
            twitter: "https://twitter.com/samkazemian"
        }
    },
    {
        image: "/images/team/violetta.png",
        name: "Violetta Ziborova",
        title: "Content Manager",
        about: "Violetta first joined IQ.wiki formerly Everipedia in 2017, and has spent several years managing IQ.wiki’s content and mentoring IQ.wiki’s community of editors.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/violetta-ziborova"
        }
    },
    {
        image: "/images/team/kevin.png",
        name: "Kevin Wang",
        title: "Director Business of Development in China",
        about: "Kevin Wang is an experienced Chinese technology executive. He manages IQ.wiki’s partnerships, marketing, and growth in China. He previously served as the President of Shenzhen Uninet Technology Co.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/kevin-wang"
        }
    },
    {
        image: "/images/team/andy.png",
        name: "Andy Cho",
        title: "Director of Business Development",
        about: "Andy Cho first joined IQ.wiki formerly Everipedia as the company’s Director of Communications in South Korea. After several years of managing key exchange and partner relationships in Korea, he was promoted to Director of Business Development.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/andy-cho"
        }
    },
    {
        image: "/images/team/robertto.png",
        name: "Roberto Dobrescu",
        title: "Director of Operations",
        about: "Roberto Dobrescu, Business Developer, is an experienced Swedish entrepreneur. He was previously the Chief Technology Officer at IM production, a company specializing in LED screens.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/roberto-dobrescu"
        }
    },
    {
        image: "/images/team/justin-moore.png",
        name: "Justin Moore",
        title: "Senior Software Engineer",
        about: "Justin Moore is an experienced software architect and full-stack developer with over a decade of experience. In June 2021, he joined the IQ.wiki team as a Senior Software Engineer.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/justin-moore",
            linkedin: "https://www.linkedin.com/in/justin-moore-83b31758/"
        }
    },
    {
        image: "/images/team/suchet.png",
        name: "Suchet Dhindsa",
        title: "Chief Operating and Financial Officer",
        about: "Suchet Dhindsa is a Norwegian economist, entrepreneur, and investor. Suchet has 10 years of experience in global expansion strategy, venture capital and emerging technologies.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/justin-moore"
        }
    },
    {
        image: "/images/team/kesar.png",
        name: "C\xe9sar Rodr\xedguez",
        title: "Chief Technology Officer",
        about: "A talented engineer, Cesar has more than 16 years of experience as a senior software engineer. Cesar has a Master’s Degree in computer science from IES La Carballeira.",
        socials: {
            iqWiki: "https://iq.wiki/wiki/cesar-rodriguez",
            twitter: "https://twitter.com/kesarito",
            linkedin: "https://www.linkedin.com/in/cesarrodriguez2"
        }
    }
];

// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/About/logos/iq-grey.svg
var iq_grey_path, iq_grey_path2, iq_grey_path3, iq_grey_path4, iq_grey_path5, iq_grey_path6, iq_grey_path7, iq_grey_path8, iq_grey_path9, iq_grey_path10, iq_grey_path11;

function iq_grey_extends() { iq_grey_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return iq_grey_extends.apply(this, arguments); }



var SvgIqGrey = function SvgIqGrey(props) {
  return /*#__PURE__*/react.createElement("svg", iq_grey_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), iq_grey_path || (iq_grey_path = /*#__PURE__*/react.createElement("path", {
    d: "M22.577 13.768c0 .445-.081.871-.23 1.264a3.567 3.567 0 0 1-6.702-.095c-2.879.207-4.525-1.078-5.21-3.527-1.728-.47-3-2.048-3-3.924 0-1.213.532-2.302 1.376-3.046a4.057 4.057 0 0 1 2.696-1.02c1.185 0 2.252.505 2.996 1.313a3.17 3.17 0 0 1 1.738-.516 3.181 3.181 0 0 1 3.185 3.137v.099a2.377 2.377 0 0 1 2.405.89c.302.4.48.895.48 1.433a2.359 2.359 0 0 1-.64 1.621c.564.63.906 1.46.906 2.37Z",
    fill: "#fff"
  })), iq_grey_path2 || (iq_grey_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M16.203 7.199a3.913 3.913 0 0 0-1.04 2.66 3.933 3.933 0 0 0 4.77 3.842m-8.597-7.77a2.734 2.734 0 0 0 2.729 2.54m4.35-.528c.293-.242.64-.41 1.012-.49m-4.924-2.72c-.458.297-.835.71-1.088 1.197",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), iq_grey_path3 || (iq_grey_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M22.577 13.768a3.562 3.562 0 0 1-3.564 3.559 3.566 3.566 0 0 1-3.368-2.39c-2.879.207-4.525-1.078-5.21-3.527-1.728-.47-3-2.048-3-3.924a4.069 4.069 0 0 1 4.072-4.066c1.185 0 2.252.505 2.996 1.313a3.183 3.183 0 0 1 4.924 2.666v.054a2.379 2.379 0 0 1 2.886 2.323c-.001.627-.244 1.196-.641 1.621.563.63.905 1.46.905 2.37Z",
    stroke: "#4A5568",
    strokeWidth: 0.81,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), iq_grey_path4 || (iq_grey_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M21.673 11.397s-.277-.287-.655-.585m-9.975 7.04a3.203 3.203 0 0 1-.295-1.034",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), iq_grey_path5 || (iq_grey_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M18.032 15.378c.126.349.19.717.19 1.088 0 1.909-1.677 3.455-3.747 3.455-1.535 0-2.854-.85-3.432-2.068a2.953 2.953 0 0 1-1.664.512c-1.377 0-2.539-.946-2.903-2.24-.26.064-.528.096-.796.096a3.254 3.254 0 0 1-1.182-6.286 2.602 2.602 0 0 1-.073-.613c0-1.63 1.517-2.95 3.388-2.95 1.074 0 2.033.435 2.653 1.115a3.556 3.556 0 0 1 1.683-.42c1.896 0 3.433 1.468 3.433 3.28 0 .042 0 .085-.003.127 1.565.287 2.754 1.722 2.754 3.449 0 .519-.107 1.012-.3 1.455Z",
    fill: "#fff"
  })), iq_grey_path6 || (iq_grey_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M16.814 13.766c.559.413.986.97 1.216 1.61m-11.557.746a3.173 3.173 0 0 1-.118-.864c0-1.223.689-2.281 1.69-2.787m-2.7-2.742c-.297.03-.581.1-.849.204m5.969-2.448h0m0 0c-.426.23-.795.542-1.084.916",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), iq_grey_path7 || (iq_grey_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M18.032 15.378c.126.349.19.717.19 1.088 0 1.909-1.677 3.455-3.747 3.455-1.535 0-2.854-.85-3.432-2.068a2.953 2.953 0 0 1-1.664.512c-1.377 0-2.539-.946-2.903-2.24-.26.064-.528.096-.796.096a3.254 3.254 0 0 1-1.182-6.286 2.602 2.602 0 0 1-.073-.613c0-1.63 1.517-2.95 3.388-2.95 1.074 0 2.033.435 2.653 1.115a3.556 3.556 0 0 1 1.683-.42c1.896 0 3.433 1.468 3.433 3.28 0 .042 0 .085-.003.127 1.565.287 2.754 1.722 2.754 3.449 0 .519-.107 1.012-.3 1.455Z",
    stroke: "#4A5568",
    strokeWidth: 0.81,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), iq_grey_path8 || (iq_grey_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M12.648 11.447A3.24 3.24 0 0 1 15 10.422c.197 0 .388.017.575.052m-.215 4.117a2.588 2.588 0 0 1-2.025.973 2.59 2.59 0 0 1-2.008-4.225",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), iq_grey_path9 || (iq_grey_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M14.483 16.846c0-.508-.128-.986-.354-1.404m-5.062-.249a2.958 2.958 0 0 1 1.868-1.245m-6.488-.978a2.8 2.8 0 0 1 2.617.296m2.711-2.678a1.971 1.971 0 0 1-1.928-.477m10.434.351a1.568 1.568 0 0 1 1.22-.285",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), iq_grey_path10 || (iq_grey_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M21.95 11.4c.37-.46.573-1.029.573-1.623a2.594 2.594 0 0 0-2.891-2.572 3.4 3.4 0 0 0-5.096-2.742 4.296 4.296 0 0 0-3.03-1.254A4.29 4.29 0 0 0 7.43 6.177c-1.806.169-3.217 1.515-3.217 3.145 0 .162.014.325.042.485a3.441 3.441 0 0 0-2.045 3.16 3.472 3.472 0 0 0 4.122 3.405c.454 1.307 1.68 2.204 3.047 2.204.555 0 1.1-.145 1.58-.422.677 1.21 2.03 1.978 3.516 1.978 1.808 0 3.335-1.128 3.808-2.665a3.778 3.778 0 0 0 4.507-3.7c0-.865-.297-1.7-.839-2.368Z",
    stroke: "#4A5568",
    strokeWidth: 1.621,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), iq_grey_path11 || (iq_grey_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M11.508 2A5.477 5.477 0 0 0 6.56 5.1c-2.019.488-3.462 2.11-3.553 4.028A4.67 4.67 0 0 0 1 12.967c0 2.55 2.056 4.63 4.6 4.673a4.447 4.447 0 0 0 3.78 2.145c.394 0 .782-.052 1.159-.156.973 1.081 2.404 1.712 3.936 1.712a5.362 5.362 0 0 0 2.908-.85 4.984 4.984 0 0 0 1.66-1.744A4.989 4.989 0 0 0 24 13.768c0-.845-.212-1.666-.616-2.399a3.785 3.785 0 0 0-.732-4.244 3.785 3.785 0 0 0-2.006-1.08 4.611 4.611 0 0 0-5.909-2.996A5.502 5.502 0 0 0 11.507 2Zm0 .786c1.134 0 2.247.42 3.099 1.163a3.822 3.822 0 0 1 5.403 2.816 3.018 3.018 0 0 1 2.938 3.012c-.001.573-.165 1.133-.472 1.617.477.695.737 1.526.737 2.374a4.202 4.202 0 0 1-4.65 4.17c-.646 1.558-2.275 2.617-4.088 2.617-1.495 0-2.865-.7-3.67-1.851a3.6 3.6 0 0 1-1.425.295c-1.43 0-2.722-.856-3.317-2.162a3.896 3.896 0 0 1-4.276-3.87 3.89 3.89 0 0 1 2.012-3.405 3.226 3.226 0 0 1-.009-.24c0-1.76 1.413-3.237 3.328-3.533a4.694 4.694 0 0 1 4.39-3.003",
    fill: "#F0F0F0"
  })));
};

/* harmony default export */ var iq_grey = (SvgIqGrey);
// EXTERNAL MODULE: ./src/components/Elements/Carousel/Carousel.tsx
var Carousel = __webpack_require__("./src/components/Elements/Carousel/Carousel.tsx");
;// CONCATENATED MODULE: ./src/components/About/AboutOurTeamSlider.tsx



const AboutOurTeamSlider = (param)=>{
    let { children  } = param;
    const settings = {
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
            topArrow: "30%",
            settings: settings,
            children: children
        })
    });
};
/* harmony default export */ var About_AboutOurTeamSlider = (AboutOurTeamSlider);

;// CONCATENATED MODULE: ./src/components/About/AboutOurTeam.tsx









const IconButtonSocial = (param)=>/*#__PURE__*/ {
    let { name , icon , onClick  } = param;
    return (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
        display: "grid",
        placeItems: "center",
        bgColor: "transparent",
        _hover: {
            bgColor: "transparent"
        },
        _focus: {
            bgColor: "transparent"
        },
        _active: {
            bgColor: "transparent"
        },
        cursor: "pointer",
        color: "gray",
        "aria-label": name,
        size: "xs",
        as: icon || iq_grey,
        onClick: onClick
    });
};
const AboutOurTeam = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
        spacing: 8,
        maxW: {
            base: "100%",
            lg: "80%",
            "2xl": "65%"
        },
        mx: "auto",
        mt: {
            base: 20,
            md: "24 !important"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                size: "lg",
                children: t("meetTeamHead")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                align: "center",
                maxW: "90%",
                mx: "auto",
                fontSize: {
                    base: "16px",
                    md: "18px",
                    xl: "20px"
                },
                children: t("meetTeamContent")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                className: "about__ourTeamSliderWrapper",
                w: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutOurTeamSlider, {
                    children: TeamData.map((teamMember)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                            display: "block !important",
                            mx: "auto",
                            alignItems: "center",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        boxSize: "150px",
                                        mx: "auto",
                                        mt: "80px",
                                        className: "teamMember__image",
                                        src: teamMember.image,
                                        alt: teamMember.name,
                                        priority: true,
                                        overflow: "hidden",
                                        rounded: "full"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                    textAlign: "center",
                                    size: "md",
                                    mt: 4,
                                    children: teamMember.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    textAlign: "center",
                                    mt: 2,
                                    opacity: 0.6,
                                    children: teamMember.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                    spacing: 4,
                                    className: "teamMember__about",
                                    display: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            textAlign: "center",
                                            mt: 2,
                                            children: teamMember.about
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                            justify: "center",
                                            spacing: 4,
                                            children: [
                                                teamMember.socials.linkedin && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonSocial, {
                                                    name: "linked in",
                                                    icon: ri_index_esm/* RiLinkedinFill */.ExP,
                                                    onClick: ()=>window.open(teamMember.socials.linkedin)
                                                }),
                                                teamMember.socials.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonSocial, {
                                                    name: "twitter",
                                                    icon: ri_index_esm/* RiTwitterFill */.x2F,
                                                    onClick: ()=>window.open(teamMember.socials.twitter)
                                                }),
                                                teamMember.socials.iqWiki && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonSocial, {
                                                    name: "IQ.Wiki",
                                                    onClick: ()=>window.open(teamMember.socials.iqWiki)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, teamMember.name))
                })
            })
        ]
    });
};
/* harmony default export */ var About_AboutOurTeam = (AboutOurTeam);

// EXTERNAL MODULE: ./src/components/SEO/Static.tsx
var Static = __webpack_require__("./src/components/SEO/Static.tsx");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
;// CONCATENATED MODULE: ./src/components/About/AboutAIIntegration.tsx






const AboutAiIntegration = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        maxW: {
            base: "100%",
            lg: "80%",
            "2xl": "90%"
        },
        bgColor: "aboutFeaturesCardBg",
        border: "1px solid",
        borderColor: "aboutFeaturesCardBorder",
        p: {
            base: 3,
            md: 8
        },
        borderRadius: "20px",
        mt: {
            base: "12",
            lg: "20 !important"
        },
        mb: {
            base: "10",
            md: "15",
            lg: "initial"
        },
        mx: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
            templateColumns: "2fr 0.5fr",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    alignSelf: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            fontSize: {
                                base: "16px",
                                md: "24px",
                                lg: "48px"
                            },
                            maxW: {
                                base: "full",
                                md: "90%"
                            },
                            color: "brandLinkColor",
                            children: t("aboutAiHeading")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            mt: "5",
                            fontSize: {
                                base: "14px",
                                lg: "19px"
                            },
                            children: t("aboutAiParagraph")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    alignSelf: {
                        base: "center",
                        md: "initial"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                        w: {
                            base: "100px",
                            md: "153px",
                            lg: "300px"
                        },
                        h: {
                            base: "100px",
                            md: "153px",
                            lg: "300px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            imgBoxSize: 300,
                            alt: "Animated Robot",
                            src: "/images/GIFs/Aboutrobot.gif"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AboutAIIntegration = (AboutAiIntegration);

;// CONCATENATED MODULE: ./src/data/OurHistory.ts
const OurHistoryData = [
    {
        year: 2014,
        content: "In 2014, when Sam Kazemain and Theodor Forselius founded Everipedia in a UCLA dorm room. Travis Moore joined early on as a Co-founder and the company’s first Chief Technology Officer. \n\nOriginally their vision for Everipedia was to be an “encyclopedia of everything,” a more modern alternative to Wikipedia. While today, the IQ token is known as a cryptocurrency, IQ began as a non-tradable points system that tracked editors' contributions on Everipedia."
    },
    {
        year: 2017,
        content: 'In December 2017, we announced our plan for Everipedia to become the world’s first blockchain encyclopedia in an exclusive with <Link href="https://www.wired.com/story/everipedia-blockchain/">Wired.</Link>'
    },
    {
        year: 2018,
        content: 'In February 2018, Everipedia raised $30 million from Galaxy Digital to build Everipedia into the world’s first blockchain encyclopedia. This raise and expansion were covered by several outlets including <Link href="https://www.engadget.com/2019-02-07-everipedia-mahbod-moghadam-larry-sanger-blockchain.html">Engadget</Link>, <Link href="https://www.reuters.com/article/us-blockchain-investment-galaxy/novogratzs-new-fund-others-invest-30-million-in-online-encyclopedia-idUSKBN1FS322">Reuters</Link>, and <Link href="https://www.yahoo.com/news/blockchain-rival-wikipedia-raises-30-181838988.html">Yahoo News</Link>. \n\nIn July 2018, Everipedia turned its IQ points system into a real token. 51% of the IQ token supply was airdropped. In August, Everipedia made history by launching as the world’s first blockchain encyclopedia.\xa0'
    },
    {
        year: 2020,
        content: 'Naturally, after Everipedia became a blockchain encyclopedia in 2018 the readership and editorship on Everipedia moved toward crypto content. In 2020, the Everipedia team continued its focus on blockchain innovation developing OraQles, a service that allows verified first parties to bring real-world information on-chain. On November 4, 2020, The Associated Press used the software to publish U.S. election race calls on Ethereum. This marked the first time a US election was called on the blockchain. The historic moment was covered by publications including <Link href="https://www.forbes.com/sites/michaeldelcastillo/2020/11/03/how-to-track-official-election-results-on-ethereum-and-eos/?sh=2eb2ff153269">Forbes</Link>, <Link href="https://www.coindesk.com/markets/2020/10/15/immutable-calls-ap-election-2020-results-will-be-recorded-on-a-blockchain/">Coindesk</Link> and <Link href="https://www.nasdaq.com/articles/immutable-calls%3A-ap-election-2020-results-will-be-recorded-on-a-blockchain-2020-10-15">Nasdaq.</Link> '
    },
    {
        year: 2022,
        content: 'In 2022, Everipedia moved to the Polygon blockchain and <Link href="https://iq.wiki/blog/il83x1k4q5FdsuVJBCbAVjMlOytJ4Q5k8tsjSxG9ixg">rebranded as IQ.Wiki</Link>. Along with the rebrand, we added several new Web3 features and integrations to serve the crypto community better. Over the past few years NFTs, DeFi, and the pace of innovation in Web3 have exploded. We’ve always been passionate about building and seeing the growth of the space inspired us to build out IQ.wiki as a hub for crypto knowledge. We rebranded to IQ.wiki to emphasize how the IQ token and cryptocurrency are central to the encyclopedia.'
    },
    {
        year: 2023,
        content: 'In February 2023, IQ.wiki became one of the first encyclopedias and decentralized applications to <Link href="https://iq.wiki/blog/qQL4YXD5VnzFRTDmDmJfwbewg8QS--PWFKtmiK4meQY">integrate artificial intelligence</Link>. IQ.wiki integrated OpenAI’s GPT-3 for tasks like summarizing articles and later upgraded to GPT-4.  In 2023, BrainDAO aims to further integrate AI within the platform, develop additional AI powered tools, and use the IQ token to incentivized the training of AI models. for the first part of the issue.'
    }
];

;// CONCATENATED MODULE: ./src/components/About/OurHistoryCard.tsx



const Paragraph = (param)=>{
    let { text  } = param;
    const parts = text.split(/(<Link.*?\/Link>)/);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontSize: {
            base: "14px",
            md: "16px",
            lg: "18px"
        },
        whiteSpace: "pre-line",
        fontWeight: 500,
        children: parts.map((part, index)=>{
            var ref, ref1;
            return part.startsWith("<Link") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                color: "brandLinkColor",
                href: (ref = part === null || part === void 0 ? void 0 : part.match(/href="(.*?)"/)) === null || ref === void 0 ? void 0 : ref[1],
                target: "_blank",
                children: (ref1 = part === null || part === void 0 ? void 0 : part.match(/>(.*?)</)) === null || ref1 === void 0 ? void 0 : ref1[1]
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: part
            }, index);
        })
    });
};
const OurHistoryCard = (param)=>{
    let { year , content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        gap: {
            base: "4",
            lg: "12"
        },
        mb: {
            base: 8,
            md: "10"
        },
        flexDirection: {
            base: "column",
            md: "row"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                fontSize: {
                    base: "30px",
                    lg: "48px"
                },
                color: "brandLinkColor",
                children: year
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                px: "5",
                py: "10",
                border: "1px solid",
                borderColor: "aboutFeaturesCardBorder",
                bgColor: "aboutFeaturesCardBg",
                borderRadius: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                    text: content
                })
            })
        ]
    });
};
/* harmony default export */ var About_OurHistoryCard = (OurHistoryCard);

;// CONCATENATED MODULE: ./src/components/About/OurHistory.tsx






const OurHistory = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        mt: {
            base: 18,
            md: "24 !important"
        },
        maxW: {
            base: "100%",
            lg: "80%",
            "2xl": "75%"
        },
        mx: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                size: "lg",
                textAlign: "center",
                children: t("historyHeading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                textAlign: "center",
                mt: "4",
                fontSize: {
                    base: "14px",
                    md: "18px",
                    lg: "24px"
                },
                lineHeight: {
                    base: "20px",
                    md: "24px",
                    lg: "36px"
                },
                children: t("historyBrief")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                mt: "15",
                children: OurHistoryData.map((history, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(About_OurHistoryCard, {
                        year: history.year,
                        content: history.content
                    }, i))
            })
        ]
    });
};
/* harmony default export */ var About_OurHistory = (OurHistory);

;// CONCATENATED MODULE: ./src/pages/about.tsx










const About = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Static/* AboutHeader */.d5, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                px: {
                    base: 6,
                    lg: 16
                },
                py: {
                    base: "10",
                    lg: 15
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutFeatures, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutAsSeenIn, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_AboutOurTeam, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutAIIntegration, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_OurHistory, {})
                ]
            })
        ]
    });
/* harmony default export */ var about = (About);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,5675,4116,892,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fabout.tsx&page=%2Fabout!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);